import $ from 'jquery'
import { HTTPServer, baseURL } from '@/common/js/ajax.js'
import { systemModule } from '@/common/js/constant.js'
import axios from 'axios'
import i18n from '@/locale/i18n'
import html2canvas from 'html2canvas'
import { Loading } from 'element-ui'
import Vue from 'vue'
import store from '@/store'
import router from '../../router'
import lrz from 'lrz'
const _this = new Vue()

const utilClass = {
  // 获取布局
  getRosterSetting() {
    let employeeInfo = this.decryptMoney(localStorage.getItem('userInfo')).employeeInfo
    if (!employeeInfo.beanroster_id) {
      return
    }
    HTTPServer.getRosterSetting({ typeText: 'beanroster', type: 1 }, true).then(res => {
      let setting = this.judgeZipOrUnzip({ data: res.content }, 'getRosterSetting', 1, [
        'getRosterSetting'
      ])
      this.getRosterDetail(employeeInfo.beanroster_id, setting)
    })
  },
  getRosterDetail(rosterid, setting) {
    let jsondata = {
      id: rosterid,
      layout: this.zip(setting)
    }
    HTTPServer.getRosterDetail(jsondata).then(res => {
      localStorage.setItem('rosterDetail', this.jsonEncrypt(JSON.stringify(res)))
    })
  },
  contains: function (arr, key1, obj, key2) {
    var i = arr.length
    var data = {}
    var obj2 = key2 ? obj[key2] : obj
    while (i--) {
      if (arr[i][key1] + '' === obj2 + '') {
        data = arr[i]
        data.i = i
        return data
      }
    }
    return false
  },
  // 数组去重 (简单数组)
  unique: function (arr) {
    return Array.from(new Set(arr))
  },
  // 数组去重 (对象数组)
  uniqueObject: function (arr) {
    let stringArr = []
    let objectArr = []
    arr.map(item => {
      stringArr.push(JSON.stringify(item))
    })
    Array.from(new Set(stringArr)).map(item => {
      objectArr.push(JSON.parse(item))
    })
    return objectArr
  },
  /**
   * 数组排序
   * arr = arr.sort(this.compare('clientTimes'))
   */
  compare(prop) {
    return function (obj1, obj2) {
      var val1 = obj1[prop]
      var val2 = obj2[prop]
      if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
        val1 = Number(val1)
        val2 = Number(val2)
      }
      if (val1 < val2) {
        return -1
      } else if (val1 > val2) {
        return 1
      } else {
        return 0
      }
    }
  },
  // 两数组取相同部分 (对象数组)
  arrayIntersection: function (arr1, arr2) {
    let array = []
    arr1.map(item => {
      arr2.map(item2 => {
        if (JSON.stringify(item) === JSON.stringify(item2)) {
          array.push(item)
        }
      })
    })
    return array
  },
  // 获取数组重复部分 (简单数组)
  arrayRepeation: function (arr) {
    let ary = arr.sort() // 数组排序
    let cffwxmsAry = []
    // 所有重复元素添加进新数组内
    for (let i = 0; i < ary.length; i++) {
      if (ary[i] === ary[i + 1]) {
        cffwxmsAry.push(ary[i])
      }
    }
    let result = []
    let isRepeated
    // 对重复元素数组进行元素去重
    for (let k = 0; k < cffwxmsAry.length; k++) {
      isRepeated = false
      for (var j = 0; j < result.length; j++) {
        if (cffwxmsAry[k] === result[j]) {
          isRepeated = true
          break
        }
      }
      if (!isRepeated) {
        result.push(cffwxmsAry[k])
      }
    }
    return result
  },
  // 数组A去除和数组B相同的部分
  arrayRemainder: function (arrA, arrB) {
    let a = []
    let b = []
    let c = []
    arrA.map(item => {
      a.push(JSON.stringify(item))
    })
    arrB.map(item => {
      b.push(JSON.stringify(item))
    })
    let aSet = new Set(a)
    let bSet = new Set(b)
    Array.from(new Set(a.concat(b).filter(v => aSet.has(v) && !bSet.has(v)))).map(item => {
      c.push(JSON.parse(item))
    })
    return c
  },
  // 获取元素的纵坐标（相对于窗口）
  getTop: function (e) {
    var offset = e.offsetTop
    if (e.offsetParent != null) offset += this.getTop(e.offsetParent)
    return offset
  },
  // 获取元素的横坐标（相对于窗口）
  getLeft: function (e) {
    var offset = e.offsetLeft
    if (e.offsetParent != null) offset += this.getLeft(e.offsetParent)
    return offset
  },
  /** 根据父级class获取父级 */
  getParent: function (e, className) {
    var menu = ''
    var parentNode = function (event) {
      if (event.className === className) {
        menu = event
        return false
      } else {
        parentNode(event.parentNode)
      }
    }
    parentNode(e.target)
    return menu
  },
  /** 判断文件类型,区分文件图标 */
  determineFileType: function (types) {
    types = types.substring(0, 1) === '.' ? types.substr(1) : types
    var fileType = types.toLowerCase()
    var icon = 'iconfont '
    var imgArr = [
      'bmp',
      'jpg',
      'png',
      'gif',
      'pcx',
      'tga',
      'exif',
      'fpx',
      'psd',
      'cdr',
      'pcd',
      'dxf',
      'ufo',
      'eps',
      'ai',
      'raw',
      'WMF',
      'webp',
      'jpeg'
    ]
    var mp4Arr = [
      'wmv',
      'asf',
      'asx',
      'rm',
      'rmvb',
      'mpg',
      'mpeg',
      'mpe',
      '3gp',
      'mov',
      'mp4',
      'm4v',
      'avi',
      'dat',
      'mkv',
      'flv',
      'vob',
      'webm'
    ]
    var mp3Arr = ['mp3', 'wma', 'ape', 'wav', 'midi', 'au', 'aif', 'ra', 'rm', 'rmx', 'amr']
    if (imgArr.includes(fileType)) {
      fileType = 'img'
      icon = 'img'
    } else if (fileType === 'svg') {
      // fileType = 'img2'
      // icon = 'svg'
      fileType = 'anyFile'
      icon += 'icon-pc-paper-any-file'
    } else if (mp4Arr.includes(fileType)) {
      fileType = 'video'
      icon += 'icon-pc-paper-video'
    } else if (mp3Arr.includes(fileType)) {
      fileType = 'voice'
      icon += 'icon-pc-paper-voice'
    } else if (fileType === 'pdf') {
      fileType = 'pdf'
      icon += 'icon-pc-paper-pdf'
    } else if (fileType === 'doc' || fileType === 'docx') {
      fileType = 'doc'
      icon += 'icon-pc-paper-doc'
    } else if (fileType === 'zip' || fileType === 'rar') {
      fileType = 'zip'
      icon += 'icon-pc-paper-zip'
    } else if (fileType === 'xls' || fileType === 'xlsx' || fileType === 'csv') {
      fileType = 'xls'
      icon += 'icon-pc-paper-xls'
    } else if (fileType === 'ai') {
      fileType = 'ai'
      icon += 'icon-pc-paper-ai'
    } else if (fileType === 'cdr') {
      fileType = 'cdr'
      icon += 'icon-pc-paper-cdr'
    } else if (fileType === 'dwg') {
      fileType = 'dwg'
      icon += 'icon-pc-paper-dwg'
    } else if (fileType === 'ppt' || fileType === 'pptx') {
      fileType = 'ppt'
      icon += 'icon-pc-paper-ppt'
    } else if (fileType === 'txt') {
      fileType = 'txt'
      icon += 'icon-pc-paper-txt'
    } else {
      fileType = 'anyFile'
      icon += 'icon-pc-paper-any-file'
    }
    return { fileType: fileType, icon: icon } // [类型, 文件图标路劲]
  },
  bteamk() {
    return 'teamface2019team'
  },
  // 判断对象的数据类型
  isClass: function (o) {
    if (o === null) return 'Null'
    if (o === undefined) return 'Undefined'
    return Object.prototype.toString.call(o).slice(8, -1)
  },
  // 克隆（简单对象，不能用于函数等）
  deepClone: function (obj) {
    return JSON.parse(JSON.stringify(obj))
  },
  // 深度克隆，推荐
  deepDeepClone: function (sth) {
    const getRegExp = re => {
      var flags = ''
      if (re.global) flags += 'g'
      if (re.ignoreCase) flags += 'i'
      if (re.multiline) flags += 'm'
      return flags
    }
    const isType = (obj, type) => {
      if (typeof obj !== 'object') return false
      // 判断数据类型的经典方法：
      const typeString = Object.prototype.toString.call(obj)
      let flag
      switch (type) {
        case 'Array':
          flag = typeString === '[object Array]'
          break
        case 'Date':
          flag = typeString === '[object Date]'
          break
        case 'RegExp':
          flag = typeString === '[object RegExp]'
          break
        default:
          flag = false
      }
      return flag
    }
    // 维护两个储存循环引用的数组
    const parents = []
    const children = []

    const _clone = parent => {
      if (parent === null) return null
      if (typeof parent !== 'object') return parent

      let child, proto

      if (isType(parent, 'Array')) {
        // 对数组做特殊处理
        child = []
      } else if (isType(parent, 'RegExp')) {
        // 对正则对象做特殊处理
        child = new RegExp(parent.source, getRegExp(parent))
        if (parent.lastIndex) child.lastIndex = parent.lastIndex
      } else if (isType(parent, 'Date')) {
        // 对Date对象做特殊处理
        child = new Date(parent.getTime())
      } else {
        // 处理对象原型
        proto = Object.getPrototypeOf(parent)
        // 利用Object.create切断原型链
        child = Object.create(proto)
      }

      // 处理循环引用
      const index = parents.indexOf(parent)

      if (index !== -1) {
        // 如果父数组存在本对象,说明之前已经被引用过,直接返回此对象
        return children[index]
      }
      parents.push(parent)
      children.push(child)

      for (let i in parent) {
        // 递归
        child[i] = _clone(parent[i])
      }

      return child
    }
    return _clone(sth)
  },
  // 时间戳转字符串
  formatDate: function (value, type) {
    if (value) {
      var date = new Date(parseInt(value))
      if (/(y+)/.test(type)) {
        type = type.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'H+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
      }
      var padLeftZero = function (str) {
        return ('00' + str).substr(str.length)
      }
      for (let k in o) {
        if (new RegExp(`(${k})`).test(type)) {
          let str = o[k] + ''
          type = type.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str))
        }
      }
      return type
    }
  },
  ateamk() {
    return utilClass.bteamk()
  },
  // 薪酬用，获取上月计薪月份
  getPreMonth(date, importDay) {
    var arr = date.split('-')
    var year = arr[0] // 获取当前日期的年份
    var month = arr[1] // 获取当前日期的月份
    var day = arr[2] // 获取当前日期的日
    var year2 = year
    var month2 = parseInt(month) - 1
    if (month2 === 0) {
      // 如果是1月份，则取上一年的12月份
      year2 = parseInt(year2) - 1
      month2 = 12
    }
    var day2 = day
    var days2 = new Date(year2, month2, 0)
    days2 = days2.getDate()
    if (day2 > days2) {
      // 如果原来日期大于上一月的日期，则取当月的最大日期。比如3月的30日，在2月中没有30
      day2 = days2
    }
    if (month2 < 10) {
      month2 = '0' + month2 // 月份填补成2位。
    }
    let importDay1 = parseInt(importDay)
    if (importDay1 < 10) {
      importDay1 = '0' + importDay1
    }
    var t2 = year2 + '-' + month2 + '-' + importDay1 + ' 00:00:00'
    return t2
  },
  // 获得某月的天数
  getMonthDays: function (myMonth) {
    var monthStartDate = new Date(new Date().getFullYear(), myMonth, 1)
    var monthEndDate = new Date(new Date().getFullYear(), myMonth + 1, 1)
    var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24)
    return days
  },
  // 获得本季度的开始月份
  getQuarterStartMonth: function () {
    var quarterStartMonth = 0
    if (new Date().getMonth() < 3) {
      quarterStartMonth = 0
    }
    if (new Date().getMonth() > 2 && new Date().getMonth() < 6) {
      quarterStartMonth = 3
    }
    if (new Date().getMonth() > 5 && new Date().getMonth() < 9) {
      quarterStartMonth = 6
    }
    if (new Date().getMonth() > 8) {
      quarterStartMonth = 9
    }
    return quarterStartMonth
  },
  // 获得本月的开始时间
  getMonthStartDate() {
    var monthStartDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1)
    return monthStartDate
  },
  // 获得本季度的开始日期
  getQuarterStartDate: function () {
    var quarterStartDate = new Date(new Date().getFullYear(), utilClass.getQuarterStartMonth(), 1)
    return quarterStartDate
  },
  // 获得本季度的结束日期
  getQuarterEndDate: function () {
    var quarterEndMonth = utilClass.getQuarterStartMonth() + 2
    var quarterStartDate = new Date(
      new Date().getFullYear(),
      quarterEndMonth,
      utilClass.getMonthDays(quarterEndMonth)
    )
    return quarterStartDate
  },
  // 上季度第一天
  getPriorSeasonFirstDay: function (year, month) {
    var spring = 0 // 春
    var summer = 3 // 夏
    var fall = 6 // 秋
    var winter = 9 // 冬
    // 月份从0-11
    switch (
      month // 季度的其实月份
    ) {
      case spring:
        // 如果是第一季度则应该到去年的冬季
        year--
        month = winter
        break
      case summer:
        month = spring
        break
      case fall:
        month = summer
        break
      case winter:
        month = fall
        break
    }
    return new Date(year, month, 1)
  },
  // 根据该月的第一天获得该月的最后一天
  getMonthEndDate(firstDay) {
    var date = new Date(firstDay)
    var currentMonth = date.getMonth()
    var nextMonth = ++currentMonth
    var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1)
    var oneDay = 1000 * 60 * 60 * 24
    return new Date(nextMonthFirstDay - oneDay).getTime()
  },
  // 根据时间戳获取星期数
  getDayofWeek(date) {
    var dt = new Date(date)
    var weekDay = ['日', '一', '二', '三', '四', '五', '六']
    return weekDay[dt.getDay()]
  },
  // 根据某月开始时间获取一个月中的所有日期数组
  getEveryDay: function (begin) {
    // (begin:月开始时间)
    begin = utilClass.formatDate(begin, 'yyyy-MM-dd')
    var end = utilClass.getMonthEndDate(begin)
    end = utilClass.formatDate(end, 'yyyy-MM-dd')
    var dateAllArr = []
    var ab = begin.split('-')
    var ae = end.split('-')
    var db = new Date(new Date().toLocaleDateString())
    db.setUTCFullYear(ab[0], ab[1] - 1, ab[2])
    var de = new Date(new Date().toLocaleDateString())
    de.setUTCFullYear(ae[0], ae[1] - 1, ae[2])
    var unixDb = db.getTime() - 24 * 60 * 60 * 1000
    var unixDe = de.getTime() - 24 * 60 * 60 * 1000
    for (var k = unixDb; k <= unixDe; ) {
      dateAllArr.push({
        dayOfWeek: utilClass.getDayofWeek(k),
        timeStamp: k,
        key: 'col-' + (dateAllArr.length + 1)
      })
      k = k + 24 * 60 * 60 * 1000
    }
    return dateAllArr
  },
  // 获取当月时间戳
  getCurrentMonthTimestamp(time) {
    let year = new Date().getFullYear()
    let month = new Date().getMonth()
    if (time) {
      year = new Date(time).getFullYear()
      month = new Date(time).getMonth()
    }
    let start = new Date(year + '-' + (month + 1) + '-1').setHours(0, 0, 0, 0)
    if (month === 11) {
      year += 1
      month = 1
    } else {
      month += 2
    }
    return [start, new Date(year + '-' + month + '-1').setHours(0, 0, 0, 0) - 1]
  },
  /** json 转 CSV文件 */
  JSONToCSV: function (tableBody, tableHeader, fileName) {
    var csv = '\ufeff'
    var keys = []
    tableHeader.forEach(function (item) {
      csv += '"' + item.coltext + '",'
      keys.push(item.colname)
    })
    csv = csv.replace(/[,]$/, '\n')
    tableBody.forEach(function (item) {
      keys.forEach(function (key) {
        csv += '"' + (item[key] ? item[key] : '') + '",'
      })
      csv = csv.replace(/[,]$/, '\n')
    })
    csv = csv.replace(/"null"/g, '""')
    var blob = new Blob([csv], {
      type: 'text/csv,charset=UTF-8'
    })
    var csvUrl = window.URL.createObjectURL(blob)
    var a = document.createElement('a')
    var now = new Date()

    function to2(num) {
      return num > 9 ? num : '0' + num
    }
    // fileName = fileName || '下载' + now.getFullYear() + to2((now.getMonth() + 1)) + to2(now.getDate()) + to2(now.getHours()) + to2(now.getMinutes()) + to2(now.getSeconds())
    fileName =
      fileName ||
      i18n.t('base_common.down') +
        now.getFullYear() +
        to2(now.getMonth() + 1) +
        to2(now.getDate()) +
        to2(now.getHours()) +
        to2(now.getMinutes()) +
        to2(now.getSeconds())
    a.download = fileName + '.csv'
    a.href = csvUrl
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  },
  options: {
    id: '',
    canvasId: 'verifyCanvas',
    width: '100',
    height: '30',
    type: 'blend',
    code: ''
  },
  /** 初始化方法 */
  verifyInit: function (options) {
    if (Object.prototype.toString.call(options) === '[object Object]') {
      for (var i in options) {
        this.options[i] = options[i]
      }
    } else {
      this.options.id = options
    }
    this.options.numArr = '0,1,2,3,4,5,6,7,8,9'.split(',')
    this.options.letterArr = this.getAllLetter()
    this.refresh()
    // var con = document.getElementById(this.options.id)
    var canvas = document.createElement('canvas')
    canvas.id = this.options.canvasId
    canvas.width = this.options.width
    canvas.height = this.options.height
    canvas.style.cursor = 'pointer'
    // canvas.innerHTML = '您的浏览器版本不支持canvas'
    canvas.innerHTML = i18n.t('utils.browserDontSupportCanvas')
    // con.appendChild(canvas)
  },
  /** 生成验证码**/
  refresh: function () {
    this.options.code = ''
    var canvas = document.getElementById(this.options.canvasId)
    if (canvas.getContext) {
      var ctx = canvas.getContext('2d')
    } else {
      return
    }
    ctx.textBaseline = 'middle'
    ctx.fillStyle = this.randomColor(180, 240)
    ctx.fillRect(0, 0, this.options.width, this.options.height)
    var txtArr = ''
    if (this.options.type === 'blend') {
      txtArr = this.options.numArr.concat(this.options.letterArr)
    } else if (this.options.type === 'number') {
      txtArr = this.options.numArr
    } else {
      txtArr = this.options.letterArr
    }
    for (var i = 1; i <= 4; i++) {
      var txt = txtArr[this.randomNum(0, txtArr.length)]
      this.options.code += txt
      ctx.font = this.randomNum(this.options.height / 2, this.options.height) + 'px SimHei'
      ctx.fillStyle = this.randomColor(50, 160)
      ctx.shadowOffsetX = this.randomNum(-3, 3)
      ctx.shadowOffsetY = this.randomNum(-3, 3)
      ctx.shadowBlur = this.randomNum(-3, 3)
      ctx.shadowColor = 'rgba(0, 0, 0, 0.3)'
      var x = (this.options.width / 5) * i
      var y = this.options.height / 2
      var deg = this.randomNum(-30, 30) /** 设置旋转角度和坐标原点**/
      ctx.translate(x, y)
      ctx.rotate((deg * Math.PI) / 180)
      ctx.fillText(txt, 0, 0) /** 恢复旋转角度和坐标原点**/
      ctx.rotate((-deg * Math.PI) / 180)
      ctx.translate(-x, -y)
    }
    /** 绘制干扰线**/
    for (var LT = 0; LT < 4; LT++) {
      ctx.strokeStyle = this.randomColor(40, 180)
      ctx.beginPath()
      ctx.moveTo(this.randomNum(0, this.options.width), this.randomNum(0, this.options.height))
      ctx.lineTo(this.randomNum(0, this.options.width), this.randomNum(0, this.options.height))
      ctx.stroke()
    }
    /** 绘制干扰点**/
    for (var FL = 0; FL < this.options.width / 40; FL++) {
      ctx.fillStyle = this.randomColor(0, 255)
      ctx.beginPath()
      ctx.arc(
        this.randomNum(0, this.options.width),
        this.randomNum(0, this.options.height),
        1,
        0,
        2 * Math.PI
      )
      ctx.fill()
    }
  },
  /** 验证验证码**/
  validateCode: function (code) {
    code = code.toLowerCase()
    var vCode = this.options.code.toLowerCase()
    if (code === vCode) {
      return true
    } else {
      return false
    }
  },
  /** 生成字母数组**/
  getAllLetter: function () {
    var letterStr =
      'a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z,A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X,Y,Z'
    return letterStr.split(',')
  },
  /** 生成一个随机数**/
  randomNum: function (min, max) {
    return Math.floor(Math.random() * (max - min) + min)
  },
  /** 生成一个随机色**/
  randomColor: function (min, max) {
    var r = this.randomNum(min, max)
    var g = this.randomNum(min, max)
    var b = this.randomNum(min, max)
    return 'rgb(' + r + ',' + g + ',' + b + ')'
  },
  // JS操作cookies方法!
  // 写cookies
  // 读取cookies
  getCookie: function (name) {
    var aCookie = document.cookie.split('; ')
    for (var i = 0; i < aCookie.length; i++) {
      var aCrumb = aCookie[i].split('=')
      if (name === aCrumb[0]) {
        return unescape(aCrumb[1]).substring(0, unescape(aCrumb[1]).length - 7)
      }
    }
    return null
  },
  // 删除cookies
  delCookie: function (name) {
    var exp = new Date()
    exp.setTime(exp.getTime() - 1)
    var cval = this.getCookie(name)
    if (cval != null) document.cookie = name + '=' + cval + 'expires=' + exp.toGMTString()
  },
  // 使用示例
  // 如果需要设定自定义过期时间
  // 那么把上面的函数换成下面两个函数就ok
  // 程序代码
  setCookie: function (name, value, time) {
    var strsec = this.getsec(time)
    var exp = new Date()
    exp.setTime(exp.getTime() + strsec * 1)
    document.cookie = name + '=' + escape(value) + 'expires=' + exp.toGMTString()
  },
  // 这是有设定过期时间的使用示例：
  // s20是代表20秒
  // h是指小时，如12小时则是：h12
  // d是天数，30天则：d30
  // 暂时只写了这三种
  getsec: function (str) {
    if (str) {
      var str1 = str.substring(1, str.length) * 1
      var str2 = str.substring(0, 1)
      if (str2 === 's') {
        return str1 * 1000
      } else if (str2 === 'h') {
        return str1 * 60 * 60 * 1000
      } else if (str2 === 'd') {
        return str1 * 24 * 60 * 60 * 1000
      }
    }
  },
  /** 密码策略 */
  pwdtest(str, type, length) {
    length = length || 6
    var bool = !(str.length >= length)
    if (bool) {
      // bool = '不符合密码最小长度' + length + '位'
      bool = i18n.t('utils.pwdRuleInfo1') + length
      return bool
    }
    if (type === 1) {
      bool = !(/[a-zA-Z]/.test(str) && /[0-9]/.test(str) && !/[^\w]/.test(str))
      if (bool) {
        bool = i18n.t('utils.pwdRuleInfo2') // '需包含字母和数字字符'
        return bool
      }
    } else if (type === 2) {
      bool = !(/[a-zA-Z]/.test(str) && /[0-9]/.test(str) && /[^\w]/.test(str))
      if (bool) {
        bool = i18n.t('utils.pwdRuleInfo3') // '需包含字母、数字和特殊字符'
        return bool
      }
    } else if (type === 3) {
      bool = !(/[a-z]/.test(str) && /[0-9]/.test(str) && /[A-Z]/.test(str) && !/[^\w]/.test(str))
      if (bool) {
        bool = i18n.t('utils.pwdRuleInfo4') // '需包含数字和大小写字母'
        return bool
      }
    } else if (type === 4) {
      bool = !(/[a-zA-Z]/.test(str) && /[A-Z]/.test(str) && /[0-9]/.test(str) && /[^\w]/.test(str))
      if (bool) {
        bool = i18n.t('utils.pwdRuleInfo5') // '需包含数字、大小写字母和特殊字符'
        return bool
      }
    }
    return false
  },
  /** 密码策略提示 */
  PwdPopover(res) {
    res.pwd_length = res.pwd_length || 6
    res.pwd_complex = res.pwd_complex || 0
    let le = i18n.t('base_common.error.PwdPopover')
    var popover = ''
    if (res.pwd_complex === 0) {
      popover = le + res.pwd_length + i18n.t('base_common.error.PwdPopover0')
    } else if (res.pwd_complex === 1) {
      popover = le + res.pwd_length + i18n.t('base_common.error.PwdPopover1')
    } else if (res.pwd_complex === 2) {
      popover = le + res.pwd_length + i18n.t('base_common.error.PwdPopover2')
    } else if (res.pwd_complex === 3) {
      popover = le + res.pwd_length + i18n.t('base_common.error.PwdPopover3')
    } else if (res.pwd_complex === 4) {
      popover = le + res.pwd_length + i18n.t('base_common.error.PwdPopover4')
    }
    return popover
  },
  /** 音频播放 */
  audioPaly: function (event) {
    var audio = document.getElementsByTagName('audio')
    for (var i = 0; i < audio.length; i++) {
      if (event.target !== audio[i]) {
        audio[i].pause()
      }
    }
  },
  /** 视频播放 */
  videoPaly: function (event) {
    var video = document.getElementsByTagName('video')
    for (var i = 0; i < video.length; i++) {
      if (event.target !== video[i]) {
        video[i].pause()
      }
    }
  },
  /** 自定义字段解析 */
  fieldValueInit(data) {
    var arr = []
    var list
    var value = data.field_value
    if (!value) {
      return value
    }
    // let property = data.field ? JSON.parse(data.field) : {}
    let property = data.field || {}
    if (data.type === 'datetime') {
      if (!value || value.toString() === '0') {
        return value
      } else {
        return this.formatDate(value, property.formatType || 'yyyy-MM-dd HH:mm')
      }
    } else if (data.type === 'area') {
      value.split(',').map(item => {
        var area1 = item.split(':')
        arr.push(area1[1])
      })
      return arr.join('')
    } else if (data.type === 'location') {
      return (typeof value === 'string' ? JSON.parse(value) : value).value || ''
    } else if (data.type === 'reference') {
      list = typeof value === 'string' ? JSON.parse(value) : value
      list = Array.prototype.isPrototypeOf(list) ? list : [{ name: list }]
      list.map(item => {
        arr.push(item.name)
      })
      return arr.join(';')
    } else if (data.type === 'number') {
      property = data.field || ''
      // 数字
      if (property.numberType === '0') {
        return this.numberCut(value, property.numberLenth)
      } else if (property.numberType === '2') {
        return this.numberCut(value, property.numberLenth) + ' %'
      } else {
        return this.numberCut(value, 0)
      }
    } else if (data.type === 'department') {
      if (data.field_value) {
        list = typeof value === 'string' ? JSON.parse(value) : value
        list.map(item => {
          arr.push(item.name)
        })
      }
      return arr.join(',')
    } else if (data.type === 'picklist' || data.type === 'multi' || data.type === 'mutlipicklist') {
      list = typeof value === 'string' ? JSON.parse(value) : value
      list = Array.prototype.isPrototypeOf(list) ? list : [{ name: list }]
      list.map(item => {
        arr.push(item.label)
      })
      return arr.join(',')
    } else if (
      data.type === 'seniorformula' ||
      data.type === 'formula' ||
      data.type === 'functionformula' ||
      data.type === 'citeformula'
    ) {
      if (property && property.numberType === '3') {
        // 文本
        return value
      } else if (property && property.numberType === '4') {
        // 日期
        if (!value || value.toString() === '0') {
          return value
        } else {
          return this.formatDate(value, property.chooseType)
        }
      } else {
        // 数字
        if (property.numberType === '0') {
          return this.numberCut(value, property.decimalLen)
        } else if (property.numberType === '2') {
          return this.numberCut(value, property.decimalLen) + ' %'
        } else {
          return this.numberCut(value, 0)
        }
      }
    } else {
      return value
    }
  },
  /** 获取浏览器相关信息 */
  browserInfo: function () {
    var browser = {
      msie: false,
      chrome: false,
      firefox: false,
      opera: false,
      safari: false,
      name: 'unknown',
      version: 0 /** 正使用浏览器的版本号 **/
    }
    var userAgent =
      window.navigator.userAgent.toLowerCase() /** 使用正则对用户当前浏览器进行判断 **/
    if (/(msie|chrome|firefox|opera|netscape)\D+(\d[\d.]*)/.test(userAgent)) {
      browser[RegExp.$1] = true
      browser.name = RegExp.$1
      browser.version = RegExp.$2
    } else if (/version\D+(\d[\d.]*).*safari/.test(userAgent)) {
      browser.safari = true
      browser.name = 'safari'
      browser.version = RegExp.$2
    }
    return browser
  },
  _insertimg(str, id) {
    document.getElementById(id).focus()
    var selection = window.getSelection ? window.getSelection() : document.selection
    var range = selection.createRange ? selection.createRange() : selection.getRangeAt(0)
    if (!window.getSelection) {
      range.pasteHTML(str)
      range.collapse(false)
      range.select()
    } else {
      document.getElementById(id).focus()
      selection.addRange(range)
      range.collapse(false)
      var hasR = range.createContextualFragment(str)
      var hasRLastChild = hasR.lastChild
      while (
        hasRLastChild &&
        hasRLastChild.nodeName.toLowerCase() === 'br' &&
        hasRLastChild.previousSibling &&
        hasRLastChild.previousSibling.nodeName.toLowerCase() === 'br'
      ) {
        var e = hasRLastChild
        hasRLastChild = hasRLastChild.previousSibling
        hasR.removeChild(e)
      }
      range.insertNode(hasR)
      if (hasRLastChild) {
        range.setEndAfter(hasRLastChild)
        range.setStartAfter(hasRLastChild)
      }
      selection.removeAllRanges()
      selection.addRange(range)
    }
  },
  /* 处理粘贴图片 */
  pastePicture: function (e, bus) {
    let that = this
    var imgReader = function (item) {
      var blob = item.getAsFile()
      var reader = new FileReader()
      var browser = that.browserInfo()
      reader.readAsDataURL(blob)
      reader.onload = function (ev) {
        var img = new Image()
        img.src = ev.target.result
        if (browser.chrome) {
          if (bus) {
            bus.emit('file-basc64', ev.target.result)
          } else {
            that._insertimg('<img src="' + ev.target.result + '" />', 'messageBox2')
          }
        }
      }
    }
    var clipboardData = e.clipboardData
    var i = 0
    var items, item, types
    if (clipboardData) {
      items = clipboardData.items
      if (!items) {
        return
      }
      item = items[0]
      types = clipboardData.types || []
      for (; i < types.length; i++) {
        if (types[i] === 'Files') {
          item = items[i]
          break
        }
      }
      if (item && item.kind === 'file' && item.type.match(/^image\//i)) {
        imgReader(item)
      }
    }
  },
  /* basc64转文件对象 （2018-5-8 后台暂不支持多文件） */
  basc64ToFile: function (basc64) {
    basc64 = basc64.replace(/^data:image\/(png|jpg|bmp|gif|jpeg);base64,/, '')
    var formData = new FormData()
    var blobBin = window.atob(basc64)
    var array = []
    for (var i = 0; i < blobBin.length; i++) {
      array.push(blobBin.charCodeAt(i))
    }
    var blob = new Blob([new Uint8Array(array)], {
      type: 'image/png'
    })
    var file = new File([blob], 'paste' + new Date().getTime() + '.png', {
      type: 'image/png'
    })
    formData.append('file[]', file)
    return formData
  },
  // 下载方法
  saveFile(data, filename) {
    var saveLink = document.createElementNS('http://www.w3.org/1999/xhtml', 'a')
    saveLink.href = data
    saveLink.download = filename
    var event = document.createEvent('MouseEvents')
    event.initMouseEvent(
      'click',
      true,
      false,
      window,
      0,
      0,
      0,
      0,
      0,
      false,
      false,
      false,
      false,
      0,
      null
    )
    saveLink.dispatchEvent(event)
  },
  // 函数节流
  throttle: function (method, delay) {
    let last = 0
    return function () {
      let now = +new Date()
      if (now - last > delay) {
        method.apply(this, arguments)
        last = now
      }
    }
  },
  // 函数防抖
  debounce: function (fun, delay) {
    return function (args) {
      let that = this
      let _args = args
      clearTimeout(fun.id)
      fun.id = setTimeout(function () {
        fun.call(that, _args)
      }, delay)
    }
  },
  // 颜色透明度
  colorOpacity: function (color, opacity) {
    // opacity = (opacity && opacity !== '不透明') ? opacity : 100
    if (opacity && opacity.includes('%')) {
    } else {
      opacity = 100
    }
    if (color && color.includes('rgba')) {
      let regex = /\((.+?)\)/g
      let str = color.match(regex)[0]
      let arr = str.substring(1, str.length - 1).split(',')
      if (arr.length === 4) {
        return `rgba(${arr[0]},${arr[1]},${arr[2]},${parseInt(opacity) / 100})`
      } else {
        return color
      }
    } else {
      let value = color
      if (value) {
        value =
          'rgba(' +
          parseInt('0x' + color.slice(1, 3)) +
          ',' +
          parseInt('0x' + color.slice(3, 5)) +
          ',' +
          parseInt('0x' + color.slice(5, 7)) +
          ',' +
          parseInt(opacity) / 100 +
          ')'
      }
      return value
    }
  },
  // 数字保留x位小数（非四舍五入）
  numberCut: function (value, decimal) {
    let newvalue = ''
    if (value && decimal) {
      newvalue = value + ''
      if (newvalue && newvalue.includes('.')) {
        let str1 = newvalue.split('.')[0]
        let str = newvalue.split('.')[1]
        if (str.length > parseInt(decimal)) {
          if (!str.substr(0, parseInt(decimal))) {
            newvalue = str1
          } else {
            newvalue = str1 + '.' + str.substr(0, parseInt(decimal))
          }
        }
      } else {
        if (parseInt(decimal) > 0) {
          let zero = '.'
          for (let i = 0; i < parseInt(decimal); i++) {
            zero += '0'
          }
          newvalue += zero
        }
      }
      return newvalue
      // number = Math.floor(value * Math.pow(100, Number(decimal))) / (Math.pow(100, Number(decimal)))
      // return number.toFixed(decimal)
    } else {
      newvalue = value + ''
      return newvalue
    }
  },
  // 数字组件或者公式返回数字类型组件，分隔符处理
  setNumDelimiter(value, delimiter) {
    // delimiter=='0' 无分隔符，delimiter=='1' 千分位分隔符，delimiter=='2' 万分位分隔符
    let newValue = ''
    let point = ''
    if (value) {
      value += ''
    }
    if (value && (value + '').includes('.')) {
      newValue = value.split('.')[0] + ''
      point = value.split('.')[1]
    } else if (value) {
      newValue = value + ''
    }
    if (newValue && delimiter) {
      if (delimiter + '' === '1') {
        let reg = /(?=(?!\b)(\d{3})+$)/g
        return point ? newValue.replace(reg, ',') + '.' + point : newValue.replace(reg, ',')
      } else if (delimiter + '' === '2') {
        let reg = /(?=(?!\b)(\d{4})+$)/g
        return point ? newValue.replace(reg, ',') + '.' + point : newValue.replace(reg, ',')
      } else {
        return value
      }
    } else {
      return value || ''
    }
  },
  // 数字格式
  numberFormat: function (value, property) {
    if (value !== '' && value !== undefined) {
      if (property.numberType === '0') {
        return utilClass.setNumDelimiter(
          utilClass.numberCut(value, property.numberLenth),
          property.numberDelimiter
        )
      } else if (property.numberType === '2') {
        return utilClass.numberCut(value, property.numberLenth) + ' %'
      } else {
        return utilClass.setNumDelimiter(utilClass.numberCut(value, 0), property.numberDelimiter)
      }
    }
  },
  // 公式格式
  formulsFormat: function (value, property) {
    if (value !== '' && value !== undefined) {
      if (property.numberType === '3') {
        // 文本
        return value
      } else if (property.numberType === '4') {
        // 日期
        if (value + '' === '0') {
          return ''
        } else {
          if ((value + '').length > 4) {
            return utilClass.formatDate(value, property.chooseType)
          } else {
            return value
          }
        }
      } else {
        // 数字
        if (property.numberType === '0') {
          return utilClass.setNumDelimiter(
            utilClass.numberCut(value, property.decimalLen),
            property.numberDelimiter
          )
        } else if (property.numberType === '2') {
          return utilClass.numberCut(value, property.decimalLen) + ' %'
        } else {
          return utilClass.setNumDelimiter(utilClass.numberCut(value, 0), property.numberDelimiter)
        }
        // return value
      }
    }
  },
  // 省市区转文本
  areaTo: function (value) {
    let text = ''
    let list = []
    if (value) {
      value.split(',').map(item => {
        list.push(item.split(':')[1])
      })
      list.map(item => {
        text += ' ' + item
      })
    }
    if (!text) {
      text = ''
    }
    return text
  },
  // 最新导出excel（支持导出子表单和富文本）
  exportTableToExcel(filds, dataList, excelName) {
    let getSubfromRight = function (item) {
      // 过滤顶层子表单名称，但保留子表单内的字段
      if (item) {
        if (item.indexOf('subform') === -1) {
          return true
        } else {
          let arr = item.split('_')
          return arr.length > 2
        }
      }
    }
    let setTdValue = function (item2, val) {
      // 设置td的值
      if (val) {
        let value
        if (
          item2.name.includes('personnel') ||
          item2.name.includes('department') ||
          item2.name.includes('reference') ||
          item2.name.includes('objective')
        ) {
          let person = []
          if (Array.isArray(val)) {
            val.map((item3, index3) => {
              person.push(item3.name)
            })
          }
          value = person.toString()
        } else if (item2.name.includes('multitext')) {
          let re1 = new RegExp('<.+?>', 'g') // 匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
          let msg = val.replace(re1, '') // 执行替换成空字符
          value = msg
        } else if (
          item2.name.includes('picklist') ||
          item2.name.includes('multi') ||
          item2.name.includes('mutlipicklist')
        ) {
          let picklist = []
          if (Array.isArray(val)) {
            val.map((item3, index3) => {
              picklist.push(item3.label)
            })
          }
          value = picklist.toString()
        } else if (item2.name.includes('location')) {
          value = val.value ? val.value : ''
        } else if (item2.name.includes('datetime')) {
          if (val) {
            if (item2.name.includes('subform_datetime')) {
              value =
                item2.field && item2.field.formatType
                  ? utilClass.formatDate(val, item2.field.formatType)
                  : utilClass.formatDate(val, 'yyyy-MM-dd')
            } else {
              value = item2.format
                ? utilClass.formatDate(val, item2.format)
                : utilClass.formatDate(val, 'yyyy-MM-dd')
            }
          } else {
            value = ''
          }
        } else if (item2.name.includes('textarea')) {
          value = val
        } else if (item2.name.includes('area')) {
          value = utilClass.areaTo(val)
        } else if (
          item2.name.includes('picture') ||
          item2.name.includes('attachment') ||
          item2.name.includes('resumeanalysis')
        ) {
          value = ''
        } else {
          value = val
        }
        return value
      } else {
        return ''
      }
    }
    // let isHaveSubfrom = false
    // filds.map((v, k) => {
    //   if (v.field.indexOf('subform') !== -1) {
    //     isHaveSubfrom = true // 判断整个字段中是否有子表单
    //   }
    // })
    let headerhtml = '' // 表头第一行
    let headerhtml1 = '' // 表头第二行
    let headerSubfrom = [] // 子表单的列子段集合
    let allColFileds = [] // 所有列字段集合（已经将子表单内字段打散）
    filds.map((v, k) => {
      if (v.type !== 'picture' && v.type !== 'attachment' && v.type !== 'resumeanalysis') {
        // 去除图片和附件字段
        if (v.field.indexOf('subform') === -1) {
          // 如果没有子表单字段则合并行数
          headerhtml += `<th rowspan="2" style="height:35px;">
              ${v.label}
            </th>`
          v.name = v.name ? v.name : v.field
          allColFileds.push(v)
        } else {
          // 如果有子表单字段则没根据子表单的字段数量动态设置合并列数
          if (v.componentList && v.componentList.length > 0) {
            let newsubfiledList = []
            v.componentList.map((v1, k1) => {
              if (
                v1.type !== 'picture' &&
                v1.type !== 'attachment' &&
                v1.type !== 'resumeanalysis'
              ) {
                headerSubfrom.push(v1)
                allColFileds.push(v1)
                newsubfiledList.push(v1)
              }
            })
            headerhtml += `<th colspan="${newsubfiledList.length}" style="height:35px;">
              ${v.label}
            </th>`
          }
        }
      }
    })
    headerSubfrom.map((v, k) => {
      headerhtml1 += `<th style="height:35px;">
          ${v.label}
        </th>`
    })
    let newDataList = []
    dataList.map((val, key) => {
      let subfromLineMax = 0 // 子表单数据列表中，数量最多的值
      let obj = {}
      val.row.map((val1, key1) => {
        if (val1.name.indexOf('subform') !== -1) {
          subfromLineMax =
            val1.value && val1.value.length > subfromLineMax ? val1.value.length : subfromLineMax
          obj[val1.name] = val1.value
        } else {
          obj[val1.name] = val1.value
        }
      })
      val.subfromLineMax = subfromLineMax
      obj.subfromLineMax = subfromLineMax
      newDataList.push(obj)
    })
    // 转换成所有行数据列表
    let datalistlast = []
    newDataList.map((v, k) => {
      let obj1 = JSON.parse(JSON.stringify(v))
      if (v.subfromLineMax > 0) {
        for (let j = 0; j < v.subfromLineMax; j++) {
          let obj = JSON.parse(JSON.stringify(v))
          if (j === 0) {
            // 合并行的数量
            obj.rowspan = v.subfromLineMax
          } else {
            // 不需要合并行
            obj.rowspan = -1
          }
          for (let i in v) {
            if (i.indexOf('subform') !== -1 && v[i] && v[i].length > 0) {
              for (let k in v[i][j]) {
                obj[k] = v[i][j][k]
              }
            }
          }
          datalistlast.push(obj)
        }
      } else {
        datalistlast.push(obj1)
      }
    })
    // 动态拼接主体部分的行和列
    let row = ''
    let cssText = 'style="mso-number-format:\'@\';"'
    datalistlast.map((v, k) => {
      let col = ''
      allColFileds.map((v1, k1) => {
        if (getSubfromRight(v1.name)) {
          if (v.rowspan && v.rowspan > 0) {
            if (v1.name.indexOf('subform') === -1) {
              col += `<td ${cssText} rowspan="${v.rowspan}">${setTdValue(v1, v[v1.name])}</td>`
            } else {
              col += `<td ${cssText}>${setTdValue(v1, v[v1.name])}</td>`
            }
          } else {
            if (v.rowspan && v.rowspan === -1) {
              if (v1.name.indexOf('subform') !== -1) {
                col += `<td ${cssText}>${setTdValue(v1, v[v1.name])}</td>`
              }
            } else {
              col += `<td ${cssText}>${setTdValue(v1, v[v1.name])}</td>`
            }
          }
        }
      })
      row += `<tr>${col}</tr>`
    })
    let tablehtml = `<table border="1" style="mso-number-format:\\@;">
                    <tr>${headerhtml}</tr>
                    <tr>${headerhtml1}</tr>
                    ${row}
                  </table>`
    var blob = new Blob([tablehtml], { type: 'application/vnd.ms-excel' })
    var a = document.createElement('a')
    // 利用URL.createObjectURL()方法为a元素生成blob URL
    a.href = URL.createObjectURL(blob)
    // 设置文件名
    a.download = excelName + '.xls'
    // const evt = document.createEvent('Event')
    // evt.initEvent('click', true, true)
    // a.dispatchEvent(evt)
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  },
  /** 获取长度 */
  calcStringPixelsCount(str, strFontSize) {
    // 字符串字符个数
    var stringCharsCount = str.length

    // 字符串像素个数
    var stringPixelsCount = 0

    // JS 创建HTML元素：span
    var elementPixelsLengthRuler = document.createElement('span')
    elementPixelsLengthRuler.style.fontSize = strFontSize // 设置span的fontsize
    elementPixelsLengthRuler.style.visibility = 'hidden' // 设置span不可见
    elementPixelsLengthRuler.style.height = '0'
    elementPixelsLengthRuler.style.position = 'absolute'
    elementPixelsLengthRuler.style.display = 'inline-block'
    elementPixelsLengthRuler.style.wordBreak = 'break-all !important' // 打断单词

    // 添加span
    document.getElementById('textNav') &&
      document.getElementById('textNav').appendChild(elementPixelsLengthRuler)

    for (var i = 0; i < stringCharsCount; i++) {
      // 判断字符是否为空格，如果是用&nbsp;替代，原因如下：
      // 1）span计算单个空格字符（ ），其像素长度为0
      // 2）空格字符在字符串的开头或者结果，计算时会忽略字符串
      if (str[i] === ' ') {
        elementPixelsLengthRuler.innerHTML = '&nbsp;'
      } else {
        elementPixelsLengthRuler.innerHTML = str[i]
      }
      stringPixelsCount += elementPixelsLengthRuler.offsetWidth
    }
    if (document.getElementById('textNav')) {
      document.getElementById('textNav').innerHTML = ''
    }
    return stringPixelsCount
  },
  GetUrlParam(url, paraName) {
    var arrObj = url.split('?')
    if (arrObj.length > 1) {
      var arrPara = arrObj[1].split('&')
      var arr
      for (var i = 0; i < arrPara.length; i++) {
        arr = arrPara[i].split('=')

        if (arr != null && arr[0] === paraName) {
          return arr[1]
        }
      }
      return ''
    } else {
      return ''
    }
  },
  // 多重条件数组排序
  objSort(arr, obj) {
    let sort = function (item1, item2) {
      var props = []
      for (var _i = 2; _i < arguments.length; _i++) {
        props[_i - 2] = arguments[_i]
      }
      var cps = [] // 存储排序属性比较结果。
      // 如果未指定排序属性，则按照全属性升序排序。
      var asc = true
      if (props.length < 1) {
        for (var p in item1) {
          if (item1[p] > item2[p]) {
            cps.push(1)
            break // 大于时跳出循环。
          } else if (item1[p] === item2[p]) {
            cps.push(0)
          } else {
            cps.push(-1)
            break // 小于时跳出循环。
          }
        }
      } else {
        for (var i = 0; i < props.length; i++) {
          var prop = props[i]
          for (var o in prop) {
            asc = prop[o] === 'ascending' ? 1 : -1
            if (item1[o] > item2[o]) {
              return asc
            } else if (item1[o] < item2[o]) {
              return -asc
            }
          }
        }
        return 0
      }
      for (var j = 0; j < cps.length; j++) {
        if (cps[j] === 1 || cps[j] === -1) {
          return cps[j]
        }
      }
      return false
    }
    return arr.sort(function (a, b) {
      return sort(a, b, obj)
    })
  },
  // https://juejin.im/post/6854818587820736526
  objSort2(name, minor) {
    return function (o, p) {
      let a, b
      if (o && p && typeof o === 'object' && typeof p === 'object') {
        a = o[name]
        b = p[name]
        if (a === b) {
          return typeof minor === 'function' ? minor(o, p) : 0
        }
        if (typeof a === typeof b) {
          return a < b ? -1 : 1
        }
        return typeof a < typeof b ? -1 : 1
      }
      // else {
      //   throw 'error'
      // }
    }
  },
  // 将数字转换为中文
  numberChinese(number) {
    let units = '个十百千万@#%亿^&~'
    let chars = '零一二三四五六七八九'
    let a = (number + '').split('')
    let s = []
    if (a.length > 12) {
      throw new Error('too big')
    } else {
      for (var i = 0, j = a.length - 1; i <= j; i++) {
        if (j === 1 || j === 5 || j === 9) {
          // 两位数 处理特殊的 1*
          if (i === 0) {
            if (a[i] !== '1') s.push(chars.charAt(a[i]))
          } else {
            s.push(chars.charAt(a[i]))
          }
        } else {
          s.push(chars.charAt(a[i]))
        }
        if (i !== j) {
          s.push(units.charAt(j - i))
        }
      }
    }
    return s
      .join('')
      .replace(/零([十百千万亿@#%^&~])/g, function (m, d, b) {
        // 优先处理 零百 零千 等
        b = units.indexOf(d)
        if (b !== -1) {
          if (d === '亿') return d
          if (d === '万') return d
          if (a[j - b] === '0') return '零'
        }
        return ''
      })
      .replace(/零+/g, '零')
      .replace(/零([万亿])/g, function (m, b) {
        // 零百 零千处理后 可能出现 零零相连的 再处理结尾为零的
        return b
      })
      .replace(/亿[万千百]/g, '亿')
      .replace(/[零]$/, '')
      .replace(/[@#%^&~]/g, function (m) {
        return { '@': '十', '#': '百', '%': '千', '^': '十', '&': '百', '~': '千' }[m]
      })
      .replace(/([亿万])([一-九])/g, function (m, d, b, c) {
        c = units.indexOf(d)
        if (c !== -1) {
          if (a[j - c] === '0') return d + '零' + b
        }
        return m
      })
  },
  /** 实现防抖函数
   * document的scroll事件上使用防抖函数
   * document.addEventListener('scroll', debouncing(scrollHandler, 100), false)
   */
  debouncing(fn, waitTime) {
    let timer
    return function () {
      let context = this
      let args = arguments
      clearTimeout(timer)
      timer = setTimeout(function () {
        fn.apply(context, args)
      }, waitTime)
    }
  },
  // 判断多级下拉二级和三级必填一项
  mutiListIsEmpty(layout) {
    let name = []
    let status = false
    let layoutCopy = utilClass.deepDeepClone(layout)
    layoutCopy.map(v => {
      v.rows.map(item2 => {
        if (item2.type === 'mutlipicklist') {
          item2.entrys.map(m1 => {
            if (typeof m1.label !== 'string') {
              m1.label = m1.label.language[i18n.locale]
            }
            if (m1.subList && m1.subList.length > 0) {
              m1.subList.map(m2 => {
                if (typeof m2.label !== 'string') {
                  m2.label = m2.label.language[i18n.locale]
                }
                if (m2.subList && m2.subList.length > 0) {
                  m2.subList.map(m3 => {
                    if (typeof m3.label !== 'string') {
                      m3.label = m3.label.language[i18n.locale]
                    }
                  })
                }
              })
            }
          })
        } else if (item2.type === 'subform') {
          item2.componentList.map((subform, index) => {
            if (subform.type === 'mutlipicklist') {
              subform.entrys.map(subformm1 => {
                if (subformm1.subList && subformm1.subList.length > 0) {
                  if (typeof subformm1.label !== 'string') {
                    subformm1.label = subformm1.label.language[i18n.locale]
                  }
                  subformm1.subList.map(subformmm2 => {
                    if (typeof subformmm2.label !== 'string') {
                      subformmm2.label = subformmm2.label.language[i18n.locale]
                    }
                    if (subformmm2.subList && subformmm2.subList.length > 0) {
                      subformmm2.subList.map(subformmm3 => {
                        if (typeof subformmm3.label !== 'string') {
                          subformmm3.label = subformmm3.label.language[i18n.locale]
                        }
                      })
                    }
                  })
                }
              })
            }
          })
        }
      })
    })
    layoutCopy.map(item => {
      item.rows.map(item2 => {
        if (item2.type === 'mutlipicklist') {
          if (Array.isArray(item2.entrys) && item2.entrys.length > 200) {
            status = true
          }
          item2.entrys.map((m1, k1) => {
            if (m1.subList && m1.subList.length === 0) {
              name.push(item2.label)
            } else if (m1.subList && m1.subList.length > 0 && item2.field.selectType === '1') {
              m1.subList.map((m2, k2) => {
                if (m2.subList && m2.subList.length === 0) {
                  name.push(item2.label)
                }
              })
            }
          })
        } else if (item2.type === 'subform') {
          item2.componentList.map((subform, index) => {
            if (subform.type === 'mutlipicklist') {
              subform.entrys.map((subformm1, k1) => {
                if (subformm1.subList && subformm1.subList.length === 0) {
                  name.push(item2.label + '.' + subform.label)
                } else if (
                  subformm1.subList &&
                  subformm1.subList.length > 0 &&
                  subform.field.selectType === '1'
                ) {
                  subformm1.subList.map((subformmm2, k2) => {
                    if (subformmm2.subList && subformmm2.subList.length === 0) {
                      name.push(item2.label + '.' + subform.label)
                    }
                  })
                }
              })
            }
          })
        }
      })
    })
    if (status) {
      name = []
    }
    return name
  },
  // 处理批量数据联动数据
  setlinkageSubmit(LinkageFields, saveData, key, subform) {
    let obj = {}
    if (LinkageFields && LinkageFields.length > 0) {
      let str = LinkageFields.join(',')
      for (let i in saveData) {
        if (i.includes('subform')) {
          if (saveData[i] && saveData[i].length > 0) {
            let newobj = key && key + '' ? saveData[i][key] : saveData[i][0]
            if (subform === i) {
              newobj = saveData[i][key]
            } else {
              newobj = saveData[i][0]
            }
            for (let j in newobj) {
              if (str.includes(j)) {
                if (j.includes('mult') || j.includes('picklist')) {
                  if (JSON.stringify(newobj[j]) === '{}' || JSON.stringify(newobj[j]) === '[]') {
                    obj[j] = ''
                  } else {
                    obj[j] = newobj[j]
                  }
                } else if (j.includes('location')) {
                  if (Object.prototype.toString.call(newobj[j]) === '[object Object]') {
                    if (newobj[j].value) {
                      obj[j] = newobj[j]
                    } else {
                      obj[j] = {}
                    }
                  } else {
                    obj[j] = {}
                  }
                } else if (j.includes('personnel') || j.includes('department')) {
                  if (Object.prototype.toString.call(newobj[j]) === '[object Array]') {
                    obj[j] = newobj[j]
                      .map((val1, key1) => {
                        return val1.id
                      })
                      .join(',')
                  }
                } else {
                  obj[j] = newobj[j]
                }
              }
            }
          }
        } else {
          if (str.includes(i)) {
            if (i.includes('mult') || i.includes('picklist')) {
              if (JSON.stringify(saveData[i]) === '{}' || JSON.stringify(saveData[i]) === '[]') {
                obj[i] = ''
              } else {
                obj[i] = saveData[i]
              }
            } else {
              obj[i] = saveData[i]
            }
          }
        }
      }
      for (let index in obj) {
        if (index.includes('reference')) {
          if (Object.prototype.toString.call(obj[index]) === '[object Object]') {
            obj[index] = obj[index].name
          } else {
            if (localStorage.getItem('BatchLinkageSessData')) {
              obj[index] = JSON.parse(localStorage.getItem('BatchLinkageSessData'))[index]
            }
          }
        }
      }
    }
    return obj
  },
  // json格式化输出
  formatJson(json, options) {
    var reg = null
    var formatted = ''
    var pad = 0
    var PADDING = '    ' // one can also use '\t' or a different number of spaces
    // optional settings
    options = options || {}
    options.newlineAfterColonIfBeforeBraceOrBracket =
      options.newlineAfterColonIfBeforeBraceOrBracket === true
    // use a space after a colon
    options.spaceAfterColon = !(options.spaceAfterColon === false)
    // begin formatting...

    // make sure we start with the JSON as a string
    if (typeof json !== 'string') {
      json = JSON.stringify(json)
    }
    // parse and stringify in order to remove extra whitespace
    // json = JSON.stringify(JSON.parse(json));可以除去多余的空格
    json = JSON.parse(json)
    json = JSON.stringify(json)

    // add newline before and after curly braces
    /* eslint-disable */
    reg = /([\{\}])/g
    json = json.replace(reg, '\r\n$1\r\n')

    // add newline before and after square brackets
    reg = /([\[\]])/g
    json = json.replace(reg, '\r\n$1\r\n')

    // add newline after comma
    reg = /(\,)/g
    json = json.replace(reg, '$1\r\n')

    // remove multiple newlines
    reg = /(\r\n\r\n)/g
    json = json.replace(reg, '\r\n')

    // remove newlines before commas
    reg = /\r\n\,/g
    json = json.replace(reg, ',')

    // optional formatting...
    if (!options.newlineAfterColonIfBeforeBraceOrBracket) {
      reg = /\:\r\n\{/g
      json = json.replace(reg, ':{')
      reg = /\:\r\n\[/g
      json = json.replace(reg, ':[')
    }
    if (options.spaceAfterColon) {
      reg = /\:/g
      json = json.replace(reg, ': ')
    }
    $.each(json.split('\r\n'), function (index, node) {
      var i = 0
      var indent = 0
      var padding = ''
      if (node.match(/\{$/) || node.match(/\[$/)) {
        indent = 1
      } else if (node.match(/\}/) || node.match(/\]/)) {
        if (pad !== 0) {
          pad -= 1
        }
      } else {
        indent = 0
      }
      for (i = 0; i < pad; i++) {
        padding += PADDING
      }
      formatted += padding + node + '\r\n'
      pad += indent
    })
    return formatted
  },
  // 四位随机数
  random4() {
    Math.floor(Math.random() * 8999 + 1000)
  },
  // 切换或者变更历史页签
  changeHistorytag(data) {
    if (!localStorage.getItem('historyTagRecordList') || !data.english_name) return false
    let taglist = JSON.parse(localStorage.getItem('historyTagRecordList'))
    let maxId = 0
    taglist.map(v => {
      if (v.type !== 'custom_module' && v.id > maxId) {
        maxId = v.id
      }
    })
    let status = false
    let senddata = {
      id: maxId + 1,
      name: '',
      active: true,
      type: '', // 页签类型：
      data: {
        path: '', // 跳转路径
        parameter: {} // 携带参数
      }
    }
    switch (data.english_name) {
      case 'project':
        senddata.name = i18n.t('base_common.project') // '项目'
        senddata.type = 'project'
        senddata.data.path = '/frontend/project/projectList?type=project&path=1-1'
        taglist.map((v, k) => {
          v.active = false
          if (v.type === 'project') {
            v.active = true
            status = true
          }
        })
        break
      case 'task':
        senddata.name = i18n.t('base_common.task') // '任务'
        senddata.type = 'task'
        senddata.data.path = '/frontend/project/projectList?type=task&path=2-1'
        senddata.data.parameter = {
          chinese_name: i18n.t('project_task.allTask'),
          id: -3,
          path: '2-1',
          type: 0,
          parentId: -2
        }
        taglist.map((v, k) => {
          v.active = false
          if (v.type === 'task') {
            v.active = true
            status = true
          }
        })
        break
      case 'taskYdt':
        senddata.name = i18n.t('base_common.taskYdt') // '待办任务'
        senddata.type = 'taskYdt'
        senddata.data.path = '/frontend/wtask'
        senddata.data.parameter = { chinese_name: i18n.t('base_common.taskYdt'), id: 0 }
        taglist.map((v, k) => {
          v.active = false
          if (v.type === 'taskYdt') {
            v.active = true
            status = true
          }
        })
        break
      case 'approval':
        senddata.name = i18n.t('base_common.approval') // '审批'
        senddata.type = 'approval'
        senddata.data.path = '/frontend/approval'
        senddata.data.parameter.id = data.id || 0
        taglist.map((v, k) => {
          v.active = false
          if (v.type === 'approval') {
            v.active = true
            status = true
            v.data.parameter.id = data.id || 0
          }
        })
        break
      case 'memo':
        senddata.name = i18n.t('base_common.memo') // '备忘录'
        senddata.type = 'memo'
        senddata.data.path = '/frontend/memo'
        senddata.data.parameter.id = 0
        taglist.map((v, k) => {
          v.active = false
          if (v.type === 'memo') {
            v.active = true
            status = true
            v.data.parameter.id = 0
          }
        })
        break
      case 'library':
        senddata.name = i18n.t('base_common.library') // '文件库'
        senddata.type = 'file_library'
        senddata.data.path = '/frontend/library'
        senddata.data.parameter.id = data.id || 1
        taglist.map((v, k) => {
          v.active = false
          if (v.type === 'file_library') {
            v.active = true
            status = true
            v.data.parameter.id = data.id || 1
          }
        })
        break
      case 'repository_libraries':
        senddata.name = i18n.t('base_common.knowledge') // '知识库'
        senddata.type = 'knowledge_base'
        senddata.data.path = '/frontend/knowledge'
        senddata.data.parameter.id = 0
        senddata.data.parameter.type = 0
        taglist.map((v, k) => {
          v.active = false
          if (v.type === 'knowledge_base') {
            v.active = true
            status = true
            v.data.parameter.id = 0
            v.data.parameter.type = 0
          }
        })
        break
      case 'analysis':
        // senddata.name = i18n.t('base_common.report') // '数据分析'
        senddata.name = i18n.t('base_common.report') // '管理驾驶舱'
        senddata.type = 'statistical_analysis'
        senddata.data.path = '/frontend/definedReport'
        taglist.map((v, k) => {
          v.active = false
          if (v.type === 'statistical_analysis') {
            v.active = true
            status = true
          }
        })
        break
      case 'email':
        senddata.name = i18n.t('base_common.email') // '邮件'
        senddata.type = 'email'
        senddata.data.path = '/frontend/EmailMain/EmailInbox'
        senddata.data.parameter.id = data.id || 0
        taglist.map((v, k) => {
          v.active = false
          if (v.type === 'email') {
            v.active = true
            status = true
            v.data.parameter.id = data.id || 0
          }
        })
        break
      case 'EmailEpistolize':
        senddata.name = '写信' // '写信'
        senddata.type = 'write_letters'
        senddata.data.path = `/frontend/EmailMain/EmailEpistolize?navId=0`
        senddata.data.parameter.id = -1
        taglist.map((v, k) => {
          v.active = false
          if (v.type === 'write_letters') {
            v.active = true
            status = true
            v.data.parameter.id = -1
            v.data.parameter.writeLettersData = {}
          }
        })
        break
      case 'assistant':
        senddata.name = '消息通知' // '消息通知'
        senddata.type = 'assistant'
        senddata.data.path = '/frontend/assistant'
        senddata.data.parameter = {}
        taglist.map((v, k) => {
          v.active = false
          if (v.type === 'assistant') {
            v.active = true
            status = true
            v.data.parameter = {}
          }
        })
        break
      case 'workbench':
        senddata.name = i18n.t('base_common.workbench') // '消息通知'
        senddata.type = 'workbench'
        senddata.data.path = '/frontend/workbench'
        senddata.data.parameter.id = data.id || 0
        taglist.map((v, k) => {
          v.active = false
          if (v.type === 'workbench') {
            v.active = true
            status = true
            v.data.parameter.id = data.id || 0
          }
        })
        break
      case 'hierarchy':
        senddata.name = i18n.t('membership_management.organizationalstructure') // '消息通知'
        senddata.type = 'hierarchy'
        senddata.data.path = '/frontend/hierarchy'
        senddata.data.parameter = {}
        taglist.map((v, k) => {
          v.active = false
          if (v.type === 'hierarchy') {
            v.active = true
            status = true
            v.data.parameter = {}
          }
        })
        break
      case 'sso':
        senddata.name = '单点登录' // '消息通知'
        senddata.type = 'sso'
        senddata.data.path = '/frontend/sso'
        senddata.data.parameter = {
          id: data.id
        }
        taglist.map((v, k) => {
          v.active = false
          if (v.type === 'sso') {
            v.active = true
            status = true
            v.data.parameter = {
              id: data.id
            }
          }
        })
        break
      case 'performance':
      case 'achievement':
        senddata.name = i18n.t('okr.base_setting_tip_35') // '绩效考核'
        senddata.type = 'performance'
        senddata.data.path = '/frontend/performance'
        senddata.data.parameter = {
          id: data.id || 0
        }
        taglist.map((v, k) => {
          v.active = false
          if (v.type === 'performance') {
            v.active = true
            status = true
            v.data.parameter = {
              id: data.id
            }
          }
        })
        break
      case 'schedule':
        senddata.name = i18n.t('base_common.schedule')
        senddata.type = 'schedule'
        senddata.data.path = '/frontend/schedule'
        taglist.map((v, k) => {
          v.active = false
          if (v.type === 'schedule') {
            v.active = true
            status = true
          }
        })
        break
    }
    if (!status) {
      taglist.push(senddata)
    }
    taglist = taglist.filter(v => v.type)
    localStorage.setItem('historyTagRecordList', JSON.stringify(taglist))
  },
  // 路由跳转
  routerJump(data, json) {
    if (json.type === 0) {
      let route = {}
      if (data.english_name === 'knowledge_document') {
        if (data.style.includes('2')) {
          route.name = 'Knowledge'
        } else if (data.style.includes('1')) {
          route.name = 'Library'
        }
      } else if (data.english_name === 'repository_libraries') {
        // 知识库
        route.name = 'Knowledge'
      } else if (data.english_name === 'library') {
        // 文件库
        route.name = 'Library'
      } else if (data.english_name === 'job') {
        // 任务
        route.name = 'jobTaskMain'
      } else if (data.english_name === 'objective') {
        // 目标管理
        route.name = 'targetDecomposeMain'
      } else if (data.english_name === 'okr') {
        route.name = 'okrView'
      } else if (data.english_name === 'project') {
        route = { name: data.path, query: { type: 'project', path: '1-1' } }
      } else {
        let exit = systemModule().find(v => v.english_name === data.english_name)
        route.name = exit.path
      }
      if (json.addForm) {
        route.addForm = true
      }
      this.changeHistorytag({ english_name: data.english_name })
      router.push(route)
    } else if (json.type === 1) {
      // 自定义应用
      let params = {
        appId: data.application_id,
        appName: data.application_name
      }
      router.push({ name: 'DataModule', query: params })
      this.dataembeddingpointSave({
        log_type: 2,
        function_name: data.application_name
      }) // 运营埋点
      store.commit('SET_CUSTOM_APP_MODULE_DATA', {
        type: 'setToCustomMain',
        isAppChange: true
      })
    } else if (json.type === 2) {
      // 自定义模块
      let oldQuery = ''
      if (location.href.includes('frontend/module')) {
        oldQuery = JSON.parse(JSON.stringify(router.currentRoute.query))
      }
      let routeData = {
        name: 'DataModule',
        query: {
          appId: data.application_id,
          appName: data.application_name,
          moduleId: data.module_id,
          moduleName: data.chinese_name,
          bean: data.english_name
        }
      }
      if (json.addForm) {
        routeData.addForm = true
      }
      router.push(routeData)
      this.dataembeddingpointSave({
        log_type: 2,
        function_name: data.application_name
      }) // 运营埋点
      this.dataembeddingpointSave({
        log_type: 3,
        function_name: data.application_name + '-' + data.chinese_name
      }) // 运营埋点
      let senddata = { type: 'setToCustomMain', isAppChange: true }
      if (json.addForm) {
        senddata.addForm = true
      }
      if (
        oldQuery &&
        oldQuery.appId + '' === data.application_id + '' &&
        oldQuery.bean === data.english_name
      ) {
        senddata.isSameappSamemodule = true // 是同一个模块
      }
      store.commit('SET_CUSTOM_APP_MODULE_DATA', senddata)
    }
  },
  // 后台基础模块返回
  goBasicBack() {
    if (localStorage.getItem('moduleSetting') === '1') {
      // 跳转到基础模块页面
      let cur = JSON.parse(localStorage.getItem('historyTagRecordList')).find(v => v.active)
      let sendRouter = { path: cur.data.path }
      if (cur.type !== 'project' && cur.type !== 'task') {
        sendRouter.query = cur.data.parameter
      }
      router.push(sendRouter)
    } else {
      // 返回
      router.push({ path: '/backend/custom?menu=2' })
    }
  },
  /* 判断是否是内网IP */
  isInnerIPFn() {
    // 暂定 186/183为云端
    let href = window.location.href
    return !(baseURL.includes(window.CloudAddressBack) || href.includes('192.168.1.240'))
  },
  // 获取本机ip地址
  getUserIP(onNewIP) {
    let myPeerConnection =
      window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection
    let pc = new myPeerConnection({
        iceServers: []
      }),
      noop = function () {},
      localIPs = {},
      ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g,
      key

    function iterateIP(ip) {
      if (!localIPs[ip]) {
        onNewIP(ip)
      }
      localIPs[ip] = true
    }
    pc.createDataChannel('')
    pc.createOffer().then(function (sdp) {
      sdp.sdp.split('\n').forEach(function (line) {
        if (line.indexOf('candidate') < 0) {
          return
        }
        line.match(ipRegex).forEach(iterateIP)
      })
      pc.setLocalDescription(sdp, noop, noop)
    })
    pc.onicecandidate = function (ice) {
      if (
        !ice ||
        !ice.candidate ||
        !ice.candidate.candidate ||
        !ice.candidate.candidate.match(ipRegex)
      ) {
        return
      }
      ice.candidate.candidate.match(ipRegex).forEach(iterateIP)
    }
  },
  // 获取本机外网ip
  getSohuIp() {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: '',
        baseURL: 'https://ipv4.icanhazip.com/'
        // baseURL: 'https://api.ipify.org/?format=json'
      })
        .then(res => {
          if (res.data && res.data) {
            resolve({ cip: res.data.replace(/\n/g, '') })
          } else {
            reject('err')
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 加密sign
  Encrypt(flag) {
    let flagNew = flag || 0
    let newCryptoJS = window.CryptoJS
    let pwd = utilClass.ateamk()
    let newIp =
      localStorage.getItem('teamfaceCustomIp') + ':' + localStorage.getItem('teamfaceCustomIp')
    let word = `${new Date().getTime()},${newIp},${flagNew},${Math.round(Math.random() * 1000)}`
    let key = newCryptoJS.enc.Utf8.parse(pwd)
    let srcs = newCryptoJS.enc.Utf8.parse(word)
    let encrypted = newCryptoJS.AES.encrypt(srcs, key, {
      mode: newCryptoJS.mode.ECB,
      padding: newCryptoJS.pad.Pkcs7
    })
    return encrypted.toString()
  },
  // 加密方法
  jsonEncrypt(obj) {
    let newCryptoJS = window.CryptoJS
    let pwd = utilClass.ateamk()
    let key = newCryptoJS.enc.Utf8.parse(pwd)
    let srcs = newCryptoJS.enc.Utf8.parse(obj)
    let encrypted = newCryptoJS.AES.encrypt(srcs, key, {
      mode: newCryptoJS.mode.ECB,
      padding: newCryptoJS.pad.Pkcs7
    })
    return encrypted.toString()
  },
  // 解密方法
  decryptMoney(res) {
    let content = res.biz_content
    if (typeof res === 'string') {
      content = res
    }
    let newCryptoJS = window.CryptoJS
    let pwd = utilClass.ateamk()
    let key = newCryptoJS.enc.Utf8.parse(pwd)
    let encrypted = newCryptoJS.AES.decrypt(content, key, {
      mode: newCryptoJS.mode.ECB,
      padding: newCryptoJS.pad.Pkcs7
    }).toString(newCryptoJS.enc.Utf8)
    if (encrypted) {
      try {
        encrypted = JSON.parse(encrypted)
      } catch (error) {}
    }
    return encrypted
  },
  // 批量联动数据处理
  setBatchLinkageData(senddata) {
    if (Object.prototype.toString.call(senddata) === '[object Object]') {
      let data = JSON.parse(JSON.stringify(senddata))
      let formatData = function (key, record) {
        if (key.includes('personnel') || key.includes('department')) {
          if (Array.isArray(record[key]) && record[key].length > 0) {
            let arr = []
            record[key].map((v, k) => {
              arr.push(v.id)
            })
            record[key] = arr.join(',')
          }
        }
        if (key.includes('reference') || key.includes('objective')) {
          if (Array.isArray(record[key]) && record[key].length > 0) {
            record[key] = record[key][0].id
          } else if (
            Object.prototype.toString.call(record[key]) === '[object Object]' &&
            record[key].id
          ) {
            record[key] = record[key].id
          } else {
            // delete record[key]
          }
        }
      }
      for (let i in data) {
        if (i.includes('subform')) {
          if (Array.isArray(data[i]) && data[i].length > 0) {
            data[i].map((v, k) => {
              for (let j in v) {
                formatData(j, v)
              }
            })
          }
        } else {
          formatData(i, data)
        }
      }
      return data
    }
  },
  // 富文本显示图片问题处理（\'）的问题
  multitextShowPic(html) {
    let data = html
    if (data && data.includes("'")) {
      data = data.replace(/\\'/g, "'")
    }
    if (data && data.includes('<p')) {
      data = data.replace(/<p/g, '<p class="custom__p_margin"')
    }
    return data
  },
  // 图内统计切换
  chooseInsetCount(value, chartOption, status) {
    if (
      chartOption &&
      chartOption.option &&
      chartOption.option.series &&
      (chartOption.option.series.length === 1 ||
        (chartOption.type === 'map' && chartOption.option.series.length > 1))
    ) {
      let series = chartOption.option.series[0]
      let num = 0
      let length = 0
      let isHaveProcenter = false
      if (series.data && Array.isArray(series.data) && series.data.length > 0) {
        let seriesData = JSON.parse(JSON.stringify(series.data))
        if (chartOption.type === 'radar') {
          seriesData = []
          if (Array.isArray(series.data[0].value)) {
            series.data[0].value.map(v => {
              seriesData.push({
                value: v
              })
            })
          }
        }
        seriesData.map((v, k) => {
          if (v.value + '' && (v.value + '').includes('%')) {
            isHaveProcenter = true
            v.value = (v.value + '').split('%')[0]
          }
          if (k === 0 && (v.value + '').includes('.')) {
            length = (v.value + '').split('.')[1].length
          }
        })
        if (value === 0) {
          // 总计
          seriesData.map(v => {
            num += parseFloat(v.value)
          })
        } else if (value === 1) {
          // 平均值
          seriesData.map(v => {
            num += parseFloat(v.value)
          })
          num = num / seriesData.length
        } else if (value === 2) {
          // 最大值
          seriesData.map(v => {
            if (parseFloat(v.value) > num) {
              num = parseFloat(v.value)
            }
          })
        } else if (value === 3) {
          // 最小值
          num = parseFloat(seriesData[0].value)
          seriesData.map(v => {
            if (parseFloat(v.value) < num) {
              num = parseFloat(v.value)
            }
          })
        }
      } else {
        chartOption.tuInsetcount = 0
      }
      if (length > 0) {
        let strNum = num + ''
        if (strNum && strNum.includes('.')) {
          let mainNum = strNum.split('.')[0]
          let subNum = strNum.split('.')[1]
          if (subNum.length < length) {
            let ln1 = length - subNum.length
            let zero = ''
            for (let i = 0; i < ln1; i++) {
              zero += '0'
            }
            num = mainNum + '.' + subNum + '' + zero
          } else if (subNum.length > length) {
            num = mainNum + '.' + subNum.substring(0, length)
            let maxNum = subNum.substring(length, length + 1)
            if (maxNum && parseInt(maxNum) >= 5) {
              let beforNum = num.substr(0, num.length - 1)
              let laseNumt = (num + '').slice(-1)
              laseNumt = 1 + parseInt(laseNumt) + ''
              num = beforNum + laseNumt
            }
          }
        } else {
          let zero = ''
          for (let i = 0; i < length; i++) {
            zero += '0'
          }
          num = strNum + '.' + zero
        }
      }
      if (num + '' && (num + '').includes('.')) {
        let resultStr = (num + '').split('.')[1]
        if (resultStr + '' && (num + '').length > 4) {
          num = (num + '').split('.')[0] + '.' + resultStr.substring(0, 4)
        }
      }
      return isHaveProcenter ? num + '%' : num
    }
  },
  // 生成pdf文件并上传
  loadPdf(id, pdfName, bean, removeId) {
    let loadingInstance = Loading.service({
      lock: true,
      text: 'Loading…',
      background: 'rgba(0, 0, 0, 0.6)'
    })
    let ele = document.querySelector(`#${id}`)
    let eleW = ele.offsetWidth // 获得该容器的宽
    let eleH = ele.offsetHeight // 获得该容器的高
    let eleOffsetTop = ele.offsetTop // 获得该容器到文档顶部的距离
    let eleOffsetLeft = ele.offsetLeft // 获得该容器到文档最左的距离
    var canvas = document.createElement('canvas')
    var abs = 0
    let winIn = document.documentElement.clientWidth || document.body.clientWidth // 获得当前可视窗口的宽度（不包含滚动条）
    let winOut = window.innerWidth // 获得当前窗口的宽度（包含滚动条）
    if (winOut > winIn) {
      abs = (winOut - winIn) / 2 // 获得滚动条宽度的一半
    }
    canvas.width = eleW * 2 // 将画布宽&&高放大两倍
    canvas.height = eleH * 2
    var context = canvas.getContext('2d')
    context.scale(2, 2)
    context.translate(-eleOffsetLeft - abs, -eleOffsetTop)
    setTimeout(() => {
      html2canvas(ele, {
        scale: 2,
        dpi: 300,
        useCORS: true // 允许canvas画布内 可以跨域请求外部链接图片, 允许跨域请求。
      }).then(canvas => {
        var contentWidth = canvas.width
        var contentHeight = canvas.height
        // 一页pdf显示html页面生成的canvas高度;
        var pageHeight = (contentWidth / 592.28) * 841.89
        // 未生成pdf的html页面高度
        var leftHeight = contentHeight
        // 页面偏移
        var position = 0
        // a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
        var imgWidth = 595.28
        var imgHeight = (595.28 / contentWidth) * contentHeight
        var pageData = canvas.toDataURL('image/jpeg', 1.0)
        var pdf = new window.JsPDF('', 'pt', 'a4')
        // 有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
        // 当内容未超过pdf一页显示的范围，无需分页
        if (leftHeight < pageHeight) {
          // 在pdf.addImage(pageData, 'JPEG', 左，上，宽度，高度)设置在pdf中显示；
          pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
          // pdf.addImage(pageData, 'JPEG', 20, 40, imgWidth, imgHeight);
        } else {
          // 分页
          while (leftHeight > 0) {
            pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
            leftHeight -= pageHeight
            position -= 841.89
            // 避免添加空白页
            if (leftHeight > 0) {
              pdf.addPage()
            }
          }
        }
        // 将pdf输入为base格式的字符串
        var buffer = pdf.output('datauristring')
        // 将base64格式的字符串转换为file文件
        var myfile = this.dataURLtoFile(buffer, pdfName)
        var formdata = new FormData()
        // formdata.append('file', buffer)
        formdata.append('file', myfile)
        formdata.append('bean', bean)
        HTTPServer.customUpload(formdata, 'Loading').then(res => {
          if (removeId) {
            $(removeId).remove()
          }
          window.gotoEmailPage(res)
          loadingInstance.close()
        })
      })
    }, 500)
  },
  // 解析base64上传附件
  dataURLtoFile(dataImage, pdfName) {
    let arr = dataImage.split(',')
    let mime = arr[0].match(/:(.*?);/)[1]
    let suffix = mime.split('/')[1]
    let bstr = atob(arr[1])
    let n = bstr.length
    let u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    let file = new File([u8arr], `${pdfName}.${suffix}`, { type: mime })
    return file
  },
  // 国际手机号处理（验证、参数处理）
  phoneVerify(codeId, phone, arr) {
    let json = {}
    let obj = arr.find(v => {
      return v.id === codeId
    })
    if (obj) {
      if (obj.value === '86' && !obj.reg.test(phone)) {
        json.error = i18n.t('base_common.error.phone')
      }
      json.prefix = '+' + obj.value + '-'
      if (obj.value === '86') {
        json.phone = phone
      } else {
        json.phone = '+' + obj.value + '-' + phone
      }
    }
    if (!phone) {
      json.error = i18n.t('base_common.error.phone_empty')
    }
    return json
  },
  // 验证手机号/邮件/工号
  phoneVerify2(codeId, phone, arr) {
    let json = {
      phone: phone
    }
    if (!phone) {
      json.error = '账户不能为空'
    } else if (Number(phone) && phone.length > 3) {
      let obj = arr.find(v => {
        return v.id === codeId
      })
      if (obj) {
        if (obj.value === '86' && !obj.reg.test(phone)) {
          json.error = i18n.t('base_common.error.phone')
        }
        json.prefix = '+' + obj.value + '-'
        if (obj.value === '86') {
          json.phone = phone
        } else {
          json.phone = '+' + obj.value + '-' + phone
        }
      }
    } else if (phone.includes('@')) {
      let email = /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/
      if (!email.test(phone)) {
        json.error = i18n.t('email.mailAddress_error')
      }
    } else {
      let isLocal = this.isInnerIPFn()
      if (isLocal) {
        if (Number(phone) || !/^[A-Za-z0-9_.-]+$/.test(phone)) {
          json.error = i18n.t('login.error.user')
        }
      } else {
        json.error = i18n.t('login.error.user')
      }
    }
    return json
  },
  phoneParsing(phone) {
    let json = {
      phone: '',
      prefix: localStorage.getItem('countryValue') || '86'
    }
    if (phone && phone.includes('-')) {
      var arr = phone.split('-')
      json = {
        prefix: arr[0].substr(1),
        phone: arr[1]
      }
    } else {
      json = {
        phone: phone,
        prefix: '86'
      }
    }
    return json
  },
  downLoadFile(res, filename, isZip) {
    var blob = new Blob([res.data], {
      type: isZip
        ? 'application/zip'
        : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
    })
    var downloadElement = document.createElement('a')
    var href = window.URL.createObjectURL(blob) // 创建下载的链接
    downloadElement.href = href
    downloadElement.download = filename // 下载后文件名
    document.body.appendChild(downloadElement)
    downloadElement.click() // 点击下载
    document.body.removeChild(downloadElement) // 下载完成移除元素
    window.URL.revokeObjectURL(href) // 释放掉blob对象
  },
  // 运营埋点保存
  dataembeddingpointSave(data) {
    let userInfo = utilClass.decryptMoney(localStorage.getItem('userInfo'))
    let senddata = {
      company_id: userInfo.companyInfo.id,
      log_type: data.log_type,
      company_name: userInfo.companyInfo.company_name,
      function_name: data.function_name,
      phone: userInfo.employeeInfo.phone,
      operation_content: data.operation_content,
      ip: localStorage.getItem('teamfaceCustomIp')
    }
    HTTPServer.dataembeddingpointSave(senddata).then(res => {})
  },
  // 处理国际化，当前语言为空的情况
  formatLanuageNoSet(dataName) {
    let status = false
    for (let i in dataName.language) {
      if (dataName.language[i] && !status) {
        status = true
        dataName.language[i18n.locale] = dataName.language[i]
      }
    }
    return dataName
  },
  // 判断字符串、字符串数组、字符串对象的类型
  typeJudgment(str) {
    let result = ''
    try {
      var obj = JSON.parse(str)
      result = Object.prototype.toString.call(obj) === '[object Array]' ? 'array' : 'object'
    } catch (err) {
      result = 'string'
    }
    return result
  },
  // 处理子表单问题
  formatCutomSubform(data, url, layoutData) {
    let newData = JSON.parse(JSON.stringify(data))
    let subDelFlag = []
    let layoutArr = []
    if (layoutData && layoutData.layout) {
      layoutData.layout.map(v1 => {
        v1.rows.map(v2 => {
          layoutArr.push(v2)
        })
      })
    }
    for (let i in data) {
      if (layoutData) {
        let isHaveProptype = false
        layoutArr.map(v => {
          if (v.name === i) {
            isHaveProptype = true
          }
        })
        if (!isHaveProptype) {
          delete data[i]
        }
      }
      if (i.includes('subform')) {
        // 2023-05-18 子表单新增编辑为空必须传空数组
        if (!newData[i]) {
          newData[i] = []
        }
      }
      if (i.includes('subform') && Array.isArray(newData[i]) && newData[i].length > 0) {
        let subformLayout = []
        layoutArr.map(v => {
          if (v.name === i) {
            subformLayout = v.componentList
          }
        })
        newData[i].map(v => {
          for (let j in v) {
            if (layoutData && subformLayout.length > 0) {
              let isHaveSubformProptype = false
              subformLayout.map(val1 => {
                if (val1.name === j) {
                  isHaveSubformProptype = true
                }
              })
              if (!isHaveSubformProptype && j !== 'id') {
                delete v[j]
              }
            }
            if (j.includes('number')) {
              if (v[j] && (v[j] + '').includes('.')) {
                let numberArr = (v[j] + '').split('.')
                v[j] =
                  (numberArr[0] === '-0' ? numberArr[0] : parseFloat(numberArr[0])) +
                  '.' +
                  numberArr[1]
              }
            } else if (j.includes('picklist') && Array.isArray(v[j]) && v[j].length > 0) {
              v[j].map(j1 => {
                delete j1.controlField
                delete j1.relyonList
              })
            } else if (
              (j.includes('department') || j.includes('personnel')) &&
              !j.includes('connect')
            ) {
              if (Array.isArray(v[j])) {
                v[j] = v[j]
                  .map(v5 => {
                    return v5.id
                  })
                  .join(',')
              }
            } else if (j.includes('reference') || j.includes('objective')) {
              if (Array.isArray(v[j])) {
                v[j] = v[j]
                  .map(v5 => {
                    return v5.id
                  })
                  .join(',')
              } else if (Object.prototype.toString.call(v[j]) === '[object Object]') {
                v[j] = v[j].id || ''
              }
            }
            if (
              j === 'sort_id' ||
              j.includes('__scrolltop') ||
              j.includes('__color') ||
              j.includes('_color') ||
              j === 'serialNum' ||
              j.includes('_id') ||
              j.includes('_arr') ||
              j.includes('_v') ||
              (j.includes('_l') && !j.includes('location'))
            ) {
              delete v[j]
            }
          }
          delete v.checked
        })
        // 2022-02-17 子表单增加 top_id 字段，为行下标
        if (
          url === 'moduleOperation/saveData' ||
          url === 'moduleOperation/completeData' ||
          url === 'moduleOperation/updateData' ||
          url === 'moduleOperation/updateCompleteData' ||
          url === 'submit/dealFormula' ||
          url === 'workflow/pass'
        ) {
          let isAddTopId = false
          if (url === 'submit/dealFormula') {
            isAddTopId = data.subform_sort + '' === '1'
          } else {
            isAddTopId = layoutData && layoutData.subform_sort + '' === '1'
          }
          if (isAddTopId) {
            newData[i].map((v, k) => {
              v.top_id = k
            })
          }
          if (url === 'submit/dealFormula') {
            delete data.subform_sort
          }
        }
      } else if (i.includes('picklist') && Array.isArray(newData[i]) && newData[i].length > 0) {
        newData[i].map(v => {
          delete v.showFields
          delete v.hidenFields
          delete v.relyonList
        })
      } else if (i.includes('number')) {
        if (newData[i] && (newData[i] + '').includes('.')) {
          let numberArr = (newData[i] + '').split('.')
          newData[i] =
            (numberArr[0] === '-0' ? numberArr[0] : parseFloat(numberArr[0])) + '.' + numberArr[1]
        }
      }
      if (url === 'submit/dealFormula') {
        // 处理实时计算子表单问题
        if (localStorage.getItem('formulaSubformOld')) {
          let arr1 = JSON.parse(localStorage.getItem('formulaSubformOld'))
          if (arr1.includes(i) && data[i].length === 0) {
            subDelFlag.push(i)
          }
        }
      }
    }
    if (url === 'submit/dealFormula' && subDelFlag.length > 0) {
      newData.sub_del_flag = subDelFlag.join(',')
    }
    return newData
  },
  // 数据分析国际化处理
  reportFormatLabel(label) {
    let locale = localStorage.getItem('language') || 'zh'
    if (label && typeof label === 'string' && label.includes('language')) {
      let arr = label.split('}.')
      if (arr.length > 1) {
        let nameNew = ''
        arr.map((v, k) => {
          let str1 = ''
          if (k < arr.length - 1) {
            str1 = JSON.parse(v + '}').language[locale] + '.'
          } else {
            if (v.includes('language')) {
              str1 = JSON.parse(v).language[locale]
              if (!str1) {
                for (let j1 in JSON.parse(v).language) {
                  if (!str1) {
                    str1 = JSON.parse(v).language[j1]
                  }
                }
              }
            } else {
              str1 = v
            }
          }
          nameNew += str1
        })
        return nameNew
      } else {
        try {
          return JSON.parse(label).language[locale]
        } catch (e) {
          return label
        }
      }
    } else if (label && typeof label === 'string') {
      return label
    } else if (label && Object.prototype.toString.call(label) === '[object Object]') {
      return label.language[locale]
    }
  },
  labelFormatTask(label) {
    let locale = localStorage.getItem('language') || 'zh'
    if (label) {
      if (typeof label === 'string' && label.includes('language')) {
        if (label.includes('}.{')) {
        } else {
          label = JSON.parse(label)
        }
      } else if (typeof label === 'string') {
        let languageObj = { language: {} }
        languageObj.language[locale] = label
        label = languageObj
      } else {
        if (!label.language[locale]) {
          for (let i in label.language) {
            if (label.language[i] && !label.language[locale]) {
              label.language[locale] = label.language[i]
            }
          }
        }
      }
    }
    return label
  },
  mutlipicklistLabel(list) {
    let arr = JSON.parse(JSON.stringify(list))
    arr.map(v => {
      v.label = utilClass.labelFormatTask(v.label)
      if (Array.isArray(v.subList)) {
        v.subList = utilClass.mutlipicklistLabel(v.subList)
      }
    })
    return arr
  },
  // 协作国际化处理
  formatlabelLanguage(rows) {
    rows.map(v => {
      v.label = utilClass.labelFormatTask(v.label)
      if (v.type === 'picklist' || v.type === 'multi' || v.type === 'mutlipicklist') {
        v.entrys = utilClass.mutlipicklistLabel(v.entrys)
      } else if (v.type === 'subform') {
        v.componentList.map(v2 => {
          v2.label = utilClass.labelFormatTask(v2.label)
          if (v2.type === 'picklist' || v2.type === 'multi' || v2.type === 'mutlipicklist') {
            v2.entrys = utilClass.mutlipicklistLabel(v2.entrys)
          }
        })
      }
    })
    return rows
  },
  /**
   * x:lng 经度
   * y:lat 纬度
   */
  // 高德转百度地图
  bd_encrypt(x, y) {
    var X_PI = (Math.PI * 3000.0) / 180.0
    var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * X_PI)
    var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * X_PI)
    x = (z * Math.cos(theta) + 0.0065).toFixed(8)
    y = (z * Math.sin(theta) + 0.006).toFixed(8)
    return {
      lng: x,
      lat: y
    }
  },
  // 百度地图转高德地图经纬度
  gd_encrypt(x, y) {
    var X_PI = (Math.PI * 3000.0) / 180.0
    x = x - 0.0065
    y = y - 0.006
    var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * X_PI)
    var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * X_PI)
    return {
      lng: z * Math.cos(theta),
      lat: z * Math.sin(theta)
    }
  },
  // 编码
  b64EncodeUnicode(str) {
    return btoa(
      encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
        return String.fromCharCode('0x' + p1)
      })
    )
  },
  // 解码
  b64DecodeUnicode(str) {
    return decodeURIComponent(
      atob(str)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        })
        .join('')
    )
  },
  // 去除字符串 html
  removeHTMLTag(str) {
    let dom = document.createElement('DIV')
    dom.innerHTML = str
    $(dom).find('style').remove()
    str = dom.innerHTML
    str = str.replace(/<\/?[^>]*>/g, ' ') // 去除HTML tag
    // str = str.replace(/[ | ]*\n/g, '\n') // 去除行尾空白
    str = str.replace(/&nbsp;/gi, ' ') // 去掉&nbsp;
    // str = str.replace(/\s/g, '') // 将空格去掉
    str = str.replace(/<[^>]+>/g, '')
    return str
  },
  // 格式化周期显示
  formatDateZhouqi(form) {
    let str = ''
    if (form.start_time && form.end_time && form.period) {
      switch (form.period + '') {
        case '1':
        case '2':
          let type = form.period === '1' ? 'yyyy' : 'yyyy-MM'
          str = this.formatDate(form.start_time, type)
          break
        case '3':
        case '4':
        case '5':
        case '6':
          let startTime = this.formatDate(form.start_time, 'yyyy')
          let obj = {
            3: i18n.t('okr.firstQuarter'), // 第一季度
            4: i18n.t('okr.secondQuarter'), // 第一季度
            5: i18n.t('okr.thirdQuarter'), // 第一季度
            6: i18n.t('okr.fourthtQuarter') // 第一季度
          }
          str = startTime + ' ' + obj[form.period]
          break
        case '7':
          let startTime1 = this.formatDate(form.start_time, 'yyyy/MM/dd')
          let endTime = this.formatDate(form.end_time, 'yyyy/MM/dd')
          str = startTime1 + ' - ' + endTime
          break
      }
    }
    return str
  },
  // 文件限制
  fileSecurity(name) {
    let typeArr = [
      '.php',
      '.htm',
      '.pht',
      '.jsp',
      '.jsw',
      '.jsv',
      '.jtml',
      '.jHtml',
      '.asp',
      '.asa',
      '.ascx',
      '.ashx',
      '.asmx',
      '.cer',
      '.sWf',
      '.htaccess'
    ]
    let type = name.substr(name.lastIndexOf('.')).toLowerCase()
    return typeArr.some(v2 => {
      return type.includes(v2)
    })
  },
  // 文件限制
  fileRestrict(params) {
    let exceed = {
      data: '',
      params: ''
    }
    let isLocal = this.isInnerIPFn()
    let typeArr = [
      '.php',
      '.htm',
      '.pht',
      '.jsp',
      '.jsw',
      '.jsv',
      '.jtml',
      '.jHtml',
      '.asp',
      '.asa',
      '.ascx',
      '.ashx',
      '.asmx',
      '.cer',
      '.sWf',
      '.htaccess'
    ]
    var e = params.entries()
    let fun = function (v) {
      if (!v.done) {
        if (v.value[0].includes('file')) {
          var size = v.value[1].size
          if (!isLocal && size / 1024 / 1024 > 100) {
            exceed = {
              data: 1,
              params: i18n.t('base_common.error.fileSize')
            }
            return
          }
          let name = v.value[1].name
          let type = name.substr(name.lastIndexOf('.')).toLowerCase()
          let exit = typeArr.some(v2 => {
            return type.includes(v2)
          })
          if (exit) {
            params.delete(v.value[0])
            exceed = {
              data: 2,
              params: params
            }
          }
        }
        fun(e.next())
      }
    }
    fun(e.next())
    return exceed
  },
  customDataFormat(item, property) {
    let resultValue = ''
    let getType = name => {
      if (name) {
        let type = name.split('_')[0]
        return type
      }
    }
    if (property.repet_query.list_field && property.repet_query.list_field.length > 0) {
      property.repet_query.list_field.map((title, k) => {
        if (title.name === item.name) {
          if (
            getType(title.name) === 'formula' ||
            getType(title.name) === 'functionformula' ||
            getType(title.name) === 'seniorformula' ||
            getType(title.name) === 'citeformula'
          ) {
            if (!(item.value + '')) {
              resultValue = '--'
            } else {
              resultValue = utilClass.formulsFormat(item.value, title.field_param)
              if (
                (title.field_param.numberType === '0' || title.field_param.numberType === '1') &&
                title.field_param.unit
              ) {
                resultValue = resultValue + ' ' + title.field_param.unit
              }
            }
          } else if (title.type === 'datetime') {
            resultValue = item.value
              ? utilClass.formatDate(
                  item.value,
                  title.field_param.formatType
                    ? title.field_param.formatType
                    : title.field_param.chooseType
                )
              : '--'
          } else if (
            title.type === 'location' ||
            title.type === 'phone' ||
            title.type === 'email'
          ) {
            if (item.value) {
              resultValue = title.type === 'location' ? item.value.value : item.value
            } else {
              resultValue = '--'
            }
          } else if (title.type === 'multitext') {
            if (!item.value) {
              resultValue = '--'
            } else if (
              item.value &&
              Object.prototype.toString.call(item.value) === '[object String]'
            ) {
              let reg = new RegExp('<.+?>', 'g')
              resultValue = item.value.replace(reg, '')
              resultValue = resultValue.replace(/&nbsp;/g, ' ')
            }
          } else if (title.type === 'area') {
            resultValue = item.value ? utilClass.areaTo(item.value) : '--'
          } else if (
            title.type === 'personnel' ||
            title.type === 'department' ||
            title.type === 'reference' ||
            title.type === 'objective'
          ) {
            if (
              item.value &&
              Object.prototype.toString.call(item.value) === '[object Array]' &&
              item.value.length > 0
            ) {
              resultValue = item.value
                .map((child, key) => {
                  return child.name
                })
                .join(',')
            } else {
              resultValue = '--'
            }
          } else if (title.type === 'number') {
            resultValue = '--'
            if (item.value + '') {
              resultValue = utilClass.numberFormat(item.value, title.field_param)
              if (
                (title.field_param.numberType === '1' || title.field_param.numberType === '0') &&
                title.field_param.unit
              ) {
                resultValue += title.field_param.unit
              }
            }
          } else {
            resultValue = item.value ? item.value : '--'
          }
          item.resultValue = resultValue
        }
      })
    }
  },
  getBase64Image(img) {
    var canvas = document.createElement('canvas')
    canvas.width = img.width
    canvas.height = img.height
    var ctx = canvas.getContext('2d')
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
    var dataURL = canvas.toDataURL()
    return dataURL
  },
  // 华巨臣 事件回调函数处理
  initHjcCallback(extnNum) {
    var emqxCallback = 'teamfaceCallback'
    var extension = extnNum
    if (emqxCallback == '') {
      emqx_debug('回调函数名称为空')
      return false
    }

    //生成随机数
    var emqx_chars = [
      '0',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      'A',
      'B',
      'C',
      'D',
      'E',
      'F',
      'G',
      'H',
      'I',
      'J',
      'K',
      'L',
      'M',
      'N',
      'O',
      'P',
      'Q',
      'R',
      'S',
      'T',
      'U',
      'V',
      'W',
      'X',
      'Y',
      'Z',
      'a',
      'b',
      'c',
      'd',
      'e',
      'f',
      'g',
      'h',
      'i',
      'j',
      'k',
      'l',
      'm',
      'n',
      'o',
      'p',
      'q',
      'r',
      's',
      't',
      'u',
      'v',
      'w',
      'x',
      'y',
      'z'
    ]
    var emqx_nums = ''
    for (var i = 0; i < 10; i++) {
      var id = parseInt(Math.random() * 61)
      emqx_nums += emqx_chars[id]
    }
    var clientId = 'client-' + extension + '-' + new Date().valueOf() + '-' + emqx_nums

    // 连接选项
    const emqx_options = {
      // 超时时间
      connectTimeout: 4000,
      // 认证信息
      clientId: clientId,
      // username: 'emqx',
      // password: 'emqx',

      // 心跳时间
      keepalive: 60,
      clean: true
    }

    // WebSocket 连接字符串
    // const emqx_url = 'wss://54.223.67.167:8083/mqtt';
    let emqx_url_custom = 'wss://kdxf.jxuntel.cn:8084/mqtt'
    if (window.hjcConfig && window.hjcConfig.requestSocketUrl) {
      emqx_url_custom = window.hjcConfig.requestSocketUrl
    }
    const emqx_url = emqx_url_custom

    const emqx_client = mqtt.connect(emqx_url, emqx_options)

    // 连接emqx服务器
    emqx_client.on('connect', () => {
      emqx_debug('Emqx 连接成功')
      emqx_oncallback('onConnect')
      // 订阅多个主题
      emqx_client.subscribe(
        //订阅主题  ['hello', 'one/two/three/#', '#'],
        ['Popscreen/' + extension + '/Uping'],
        { qos: 1 },
        err => {
          emqx_debug('订阅成功：' + 'Popscreen/' + extension + '/Uping')
        }
      )
    })

    //接收回调
    emqx_client.on('message', (topic, message) => {
      emqx_oncallback('onMessageArrived', message.toString())
    })

    emqx_client.on('reconnect', error => {
      emqx_debug('正在重连:' + error)
      emqx_oncallback('onConnectionLost')
    })

    emqx_client.on('error', error => {
      emqx_debug('连接失败:' + error)
      emqx_oncallback('onFailure')
    })

    // document.getElementById("close").onclick = function(){
    //   emqx_client.disconnect(true)

    // }

    //执行外部回调函数
    function emqx_oncallback(type, content = '') {
      var data = ''
      if (type == 'onMessageArrived') {
        data = content
      } else if (type == 'onConnectionLost') {
        data = '{"Event": "MqttStatus", "Status": "-1", "Desc":"客户端断开连接！"}'
      } else if (type == 'onFailure') {
        data = '{"Event": "MqttStatus", "Status": "-2", "Desc":"客户端连接失败!"}'
      } else if (type == 'onConnect') {
        data = '{"Event": "MqttStatus", "Status": "0", "Desc":"客户端连接成功!"}'
      }
      try {
        if (typeof eval(emqxCallback) == 'function') {
          eval(emqxCallback)(data)
        }
      } catch (e) {
        emqx_debug('回调函数不存在, 不做回调处理')
      }
    }

    function emqx_debug(content) {}

    function close(emqx_client) {
      emqx_client.disconnect()
    }
  },
  // 提交数据去前后空格
  formatDataTrim(jsonData) {
    let deepFormat = data => {
      if (Array.isArray(data)) {
        // 数组
        data.map(v => {
          if (Object.prototype.toString.call(data) === '[object Object]') {
            for (let i in v) {
              if (v[i] && typeof v[i] === 'string') {
                v[i] = v[i].trim()
              } else {
                deepFormat(v[i])
              }
            }
          }
        })
      } else if (Object.prototype.toString.call(data) === '[object Object]') {
        // 对象
        for (let i in data) {
          if (data[i] && typeof data[i] === 'string') {
            data[i] = data[i].trim()
          } else {
            deepFormat(data[i])
          }
        }
      }
    }
    deepFormat(jsonData)
    return jsonData
  },
  formatTokrNav(data) {
    if (data.commonApplication) {
      data.commonApplication.map(v => {
        if (v.english_name === 'okr') {
          v.chinese_name = i18n.t('okr.teamface_okr') // '目标管理'
        }
      })
    }
  },
  // 获取子表单
  handleCustomSubformDetails(data) {
    if (data && Array.isArray(data.dataList)) {
      data.dataList.map(v => {
        for (let i in v) {
          if (i.includes('connect')) {
            // 跨组织
            if (v[i] && typeof v[i] === 'string') {
              try {
                let connectArr = JSON.parse(v[i])
                connectArr.map(nect => {
                  nect.connect_name = nect.companyName + '-' + nect.name
                })
                v[i] = connectArr
              } catch (error) {}
            }
          }
        }
      })
    }
  },
  // 获取自定一详情处理数据
  handleCustomDetailData(data) {
    if (data) {
      for (let i in data) {
        if (i.includes('picklist') || i.includes('multi')) {
          if (i.includes('_l') || i.includes('_v')) {
            delete data[i]
          }
        } else if (i.includes('connect')) {
          // 跨组织
          if (data[i] && typeof data[i] === 'string') {
            try {
              let connectArr = JSON.parse(data[i])
              connectArr.map(nect => {
                nect.connect_name = nect.companyName + '-' + nect.name
              })
              data[i] = connectArr
            } catch (error) {}
          }
        } else if (i.includes('subform') && Array.isArray(data[i]) && data[i].length > 0) {
          data[i].map(v => {
            for (let j in v) {
              if (j.includes('picklist') || j.includes('multi')) {
                if (j.includes('_l') || j.includes('_v')) {
                  delete v[j]
                }
              } else if (j.includes('connect')) {
                // 跨组织
                if (v[j] && typeof v[j] === 'string') {
                  try {
                    let connectArr = JSON.parse(v[j])
                    connectArr.map(nect => {
                      nect.connect_name = nect.companyName + '-' + nect.name
                    })
                    v[j] = connectArr
                  } catch (error) {}
                }
              }
            }
          })
        }
      }
    }
  },
  //增加二级控制判断 --dougj2025-12-24
  handleSecondCtrlField(option, saveData) {
    // 从layoutJson找到二级控制字段 secondCtrlFieldName ，根据所选值，再去找显示和隐藏字段
    const option_0 = option[0]
    const secondCtrlFieldName = option_0.secondCtrlFieldName
    if (option_0.secondEntrys && option_0.secondEntrys.length > 0) {
      const resultList = []
      option.map(item => {
        const secondEntrys = item.secondEntrys || []
        //增加二级控制判断 --dougj2025-12-23
        //从layoutJson找到二级控制字段 secondCtrlFieldName ，根据所选值，再去找显示和隐藏字段
        const rawValue = saveData[secondCtrlFieldName]
        if (rawValue) {
          const selectedValues = utilClass.normalizeValues(rawValue)
          if (!selectedValues || selectedValues.length === 0) return
          const valueSet = new Set(selectedValues)
          // 取出所有需要显示和隐藏的值
          resultList.push(...secondEntrys.filter(v => valueSet.has(v.value)))
        }
      })
      return resultList
    } else {
      return option
    }
  },
  setShowHideFields(list, initField, layoutJson, saveData) {
    // initField是新增或编辑初始化时需要传的，如果时隐藏的字段则不需要走下拉控制逻辑
    let isHandleControl = false
    if (initField) {
      layoutJson.map(item => {
        item.rows.map(v1 => {
          if (v1.name === initField.name) {
            if (v1.field.selectHide !== '1') {
              isHandleControl = true
            }
          }
        })
      })
    }
    if (!initField || isHandleControl) {
      let showField = [] // 需要显示的字段
      let hideField = [] // 需要隐藏的字段
      const options = saveData ? utilClass.handleSecondCtrlField(list, saveData) : list
      options.map(v1 => {
        if (Array.isArray(v1.hidenFields) && v1.hidenFields.length > 0) {
          hideField.push(...v1.hidenFields)
        }
        if (Array.isArray(v1.showFields) && v1.showFields.length > 0) {
          showField.push(...v1.showFields)
        }
        // if (v1.showFields) {
        //   showField.push(...v1.showFields)
        // }
        // if (v1.hidenFields) {
        //   hideField.push(...v1.hidenFields)
        // }
      })
      // 数据去重
      showField = utilClass.uniqueObject(showField).map(v1 => v1.name)
      hideField = utilClass.uniqueObject(hideField).map(v1 => v1.name)
      hideField = hideField.filter(v1 => !showField.includes(v1))
      layoutJson.map(item => {
        item.rows.map(field => {
          // 需要优先处理显示，再隐藏（因为隐藏会清空数据中的值）
          if (showField.includes(field.name)) {
            _this.$set(field.field, 'selectHide', '0')
          }
          if (hideField.includes(field.name)) {
            _this.$set(field.field, 'selectHide', '1')
          }
        })
      })
      // 处理隐藏逻辑 start
      if (saveData) {
        hideField.map(name => {
          saveData[name] = ''
        })
      }
      return { showField: showField, hideField: hideField }
    } else {
      return false
    }
  },
  // 新版OKR处理目标类型 2022-04-21
  judgeOtypeAuth() {
    let userInfoData = utilClass.decryptMoney(localStorage.getItem('userInfo'))
    let isCompany = false
    let isDepAuth = false
    let isTeamAuth = false
    let isPersnalAuth = false
    let basicSettingData = localStorage.getItem('basicSettingData')
    if (basicSettingData && basicSettingData !== '{}') {
      let data = JSON.parse(localStorage.getItem('basicSettingData'))
      if (data.okr_type_setting.company_okr === 1) {
        // 判断公司级
        if (data.okr_type_setting.company_okr_auth === 1) {
          // 所有人
          isCompany = true
        } else if (data.okr_type_setting.company_okr_auth === 0) {
          // 公司负责人
          if (userInfoData.employeeInfo.role_type.includes(2)) {
            isCompany = true
          }
        } else {
          // 自定义人员
          let obj = data.okr_type_setting.company_okr_users.find(
            v => v.id + '' === userInfoData.employeeInfo.id + ''
          )
          if (obj) {
            isCompany = true
          }
        }
      }
      if (data.okr_type_setting.department_okr === 1) {
        // 判断部门级
        if (data.okr_type_setting.department_okr_auth === 1) {
          // 所有人
          isDepAuth = true
        } else if (data.okr_type_setting.department_okr_auth === 0) {
          // 部门负责人
          let isLeader = userInfoData.departmentInfo.find(v => v.leader + '' === '1')
          if (isLeader) {
            isDepAuth = true
          }
        } else {
          // 自定义人员
          let obj = data.okr_type_setting.department_okr_users.find(
            v => v.id + '' === userInfoData.employeeInfo.id + ''
          )
          if (obj) {
            isDepAuth = true
          }
        }
      }
      if (data.okr_type_setting.team_okr === 1) {
        // 团队级
        if (data.okr_type_setting.team_okr_auth === 1) {
          // 所有人
          isTeamAuth = true
        } else {
          // 自定义人员
          let obj = data.okr_type_setting.team_okr_users.find(
            v => v.id + '' === userInfoData.employeeInfo.id + ''
          )
          if (obj) {
            isTeamAuth = true
          }
        }
      }
      if (data.okr_type_setting.personal_okr === 1) {
        // 判断个人级
        if (data.okr_type_setting.personal_okr_auth === 1) {
          // 所有人
          isPersnalAuth = true
        } else {
          // 自定义人员
          let obj = data.okr_type_setting.personal_okr_users.find(
            v => v.id + '' === userInfoData.employeeInfo.id + ''
          )
          if (obj) {
            isPersnalAuth = true
          }
        }
      }
    } else {
      isCompany = true
      isDepAuth = true
      isTeamAuth = true
      isPersnalAuth = true
    }
    return {
      isCompany: isCompany,
      isDepAuth: isDepAuth,
      isTeamAuth: isTeamAuth,
      isPersnalAuth: isPersnalAuth
    }
  },
  // 2022-07-11 gzip压缩和解压
  zip(content) {
    // 压缩
    if (typeof content !== 'string') {
      content = JSON.stringify(content)
    }
    let binaryString = window.pako.gzip(content, { to: 'string' })
    return btoa(binaryString)
  },
  unzip(b64Data) {
    // 解压
    let strData = atob(b64Data)
    // 将二进制字符串转换为字符数数组
    let charData = strData.split('').map(function (x) {
      return x.charCodeAt(0)
    })
    // 把数字数组转换成字节数组
    let binData = new Uint8Array(charData)
    // 解压
    let data = pako.inflate(binData)
    //将解压缩完成的的byteArray转换回ascii字符串:
    strData = new TextDecoder('utf-8').decode(data) //大数据使用此方法
    let resultData = ''
    try {
      resultData = JSON.parse(strData)
    } catch (error) {
      resultData = strData
    }
    return resultData
  },
  judgeZipOrUnzip(data, url, status, list) {
    // 处理压缩和解压
    let urls = [
      '/dataAnalysis/getDataAnalysisDetail',
      '/dataAnalysis/getDataAnalysisLayout',
      'layout/getEnableLayoutBack',
      'layout/getEnableLayout',
      'workflow/getWorkflowLayoutBack',
      'bizflow/getBizflow'
    ] // 解压接口
    if (status === 0) {
      // 压缩
      urls = [
        '/dataAnalysis/saveDataAnalysisLayout',
        '/dataAnalysis/cacheDataAnalysisChart',
        'layout/saveAllLayout',
        'workflow/saveWorkflow',
        'bizflow/saveBizflow',
        'layout/updateTableColumn'
      ]
    }
    if (list) {
      urls = list
    }
    if (status === 0 && urls.includes(url) && data) {
      // 压缩
      return { data: utilClass.zip(data) }
    } else if (
      status === 1 &&
      urls.includes(url) &&
      data &&
      data.data &&
      typeof data.data === 'string'
    ) {
      // 解压
      return utilClass.unzip(data.data)
    } else {
      return data
    }
  },
  languageFilter(label) {
    if (typeof label === 'string') {
      if (label.includes('language')) {
        return JSON.parse(label).language[i18n.locale]
      } else {
        return label
      }
    } else if (label) {
      return label.language[i18n.locale]
    }
  },
  judgeResponRespon(url) {
    return [
      'okr/saveKRData',
      'salaryAccounting/importIndividualIncomeTax',
      'roster/exportDatas',
      'roster/exportRosterTeamplate',
      'roster/exportEmployeeRemind',
      'rewardAndPunish/exportReward',
      'rewardAndPunish/exportPunish',
      'employeeCareService/exportBirth',
      'employeeCareService/exportEntryAnniversary',
      'roster/exportEntrys',
      'contractManagementService/exportContract',
      'contractManagementService/exportAgreement',
      'payrollGiveOut/saveGiveOutTemplate',
      'roster/exportSubmits',
      'roster/exportApprovalResult',
      'roster/exportMonthData',
      'employee/saveBeanData',
      'salaryPayroll/manualSync',
      'roster/exportTransfers',
      'roster/exportTransferLogs',
      'roster/exportLeavers',
      'attendanceHoliday/exportLeaveGave',
      'attendanceHoliday/exportLeaveGaveUpdate',
      'attendanceHoliday/exportLeaveGaveSum',
      'attendanceHoliday/exportLeavers',
      'attendanceOutworker/caclTime',
      'attendanceGroupNew/checkEmployeeAttendanceGroup',
      'attendanceOvertime/caclTime',
      'attendanceApplyLeave/caclTime'
    ].includes(url)
  },
  // 数字转大写
  toUpper(amount) {
    //形参
    // 汉字的数字
    const cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
    // 基本单位
    const cnIntRadice = ['', '拾', '佰', '仟']
    // 对应整数部分扩展单位
    const cnIntUnits = ['', '万', '亿', '兆']
    // 对应小数部分单位
    const cnDecUnits = ['角', '分']
    // 整数金额时后面跟的字符
    const cnInteger = '整'
    // 整型完以后的单位
    const cnIntLast = '元'
    // 最大处理的数字
    const maxNum = 9999999999999999.99
    // 金额整数部分
    let integerNum
    // 金额小数部分
    let decimalNum
    // 输出的中文金额字符串
    let chineseStr = ''
    // 分离金额后用的数组，预定义
    let parts
    if (amount === '') {
      return ''
    }
    amount = parseFloat(amount)
    if (amount >= maxNum) {
      // 超出最大处理数字
      return ''
    }
    if (amount === 0) {
      chineseStr = cnNums[0] + cnIntLast + cnInteger
      return chineseStr
    }
    // 转换为字符串
    amount = amount.toString()
    if (amount.indexOf('.') === -1) {
      integerNum = amount

      decimalNum = ''
    } else {
      parts = amount.split('.')
      integerNum = parts[0]
      decimalNum = parts[1].substr(0, 4)
    }
    // 获取整型部分转换
    if (parseInt(integerNum, 10) > 0) {
      let zeroCount = 0
      const IntLen = integerNum.length
      for (let i = 0; i < IntLen; i++) {
        const n = integerNum.substr(i, 1)
        const p = IntLen - i - 1
        const q = p / 4
        const m = p % 4
        if (n === '0') {
          zeroCount++
        } else {
          if (zeroCount > 0) {
            chineseStr += cnNums[0]
          }
          // 归零
          zeroCount = 0
          //alert(cnNums[parseInt(n)])
          chineseStr += cnNums[parseInt(n)] + cnIntRadice[m]
        }
        if (m === 0 && zeroCount < 4) {
          chineseStr += cnIntUnits[q]
        }
      }
      chineseStr += cnIntLast
    }
    // 小数部分
    if (decimalNum !== '') {
      const decLen = decimalNum.length
      for (let i = 0; i < decLen; i++) {
        const n = decimalNum.substr(i, 1)
        if (n !== '0') {
          chineseStr += cnNums[Number(n)] + cnDecUnits[i]
        }
      }
    }
    if (chineseStr === '') {
      chineseStr += cnNums[0] + cnIntLast + cnInteger
    } else if (decimalNum === '') {
      chineseStr += cnInteger
    }
    return chineseStr //转好的大写文字
  },
  wrapperZindex() {
    let max = 0
    let doms = document.querySelectorAll('.el-dialog__wrapper')
    for (var index = 0; index < doms.length; index++) {
      if (doms[index]) {
        if (max < doms[index].style.zIndex) {
          max = doms[index].style.zIndex
        }
      }
    }
    return
  },
  // WEB表单url
  webUrlInit(signatrue) {
    let webUrl = ''
    if (this.isInnerIPFn()) {
      webUrl =
        location.protocol + '//' + location.host + '/dist/H5.html#/' + (signatrue || 'induction/')
    } else {
      webUrl = process.env.VUE_APP_ADDRESS_WEB_FORM + '/#/' + (signatrue || 'induction/')
    }
    return webUrl
  },
  // 获取俩时间年月日
  calculateDiffTime(start, end) {
    let runTime = parseInt((end - start) / 1000)
    var year = Math.floor(runTime / 86400 / 365)
    runTime = runTime % (86400 * 365)
    var month = Math.floor(runTime / 86400 / 30)
    runTime = runTime % (86400 * 30)
    var day = Math.floor(runTime / 86400)
    runTime = runTime % 86400
    var hour = Math.floor(runTime / 3600)
    runTime = runTime % 3600
    var minute = Math.floor(runTime / 60)
    runTime = runTime % 60
    var second = runTime
    return {
      year: year,
      month: month,
      day: day,
      hour: hour,
      minute: minute,
      second: second
    }
  },
  // 获取数组路劲
  getArrUrl(arr, id, key) {
    function searchPath(node) {
      let path = []
      path.unshift(node[key])
      while (node.parent) {
        node = node.parent
        path.unshift(node[key])
      }
      return path
    }
    function search3(tree, value) {
      let qunt = []
      let nodes = null
      if (tree.length > 0) {
        qunt.push(...tree)
      }
      while (qunt.length > 0) {
        let node = qunt.shift()
        if (node.id === value) {
          nodes = node
          break
        }
        if (node.childList) {
          let arr2 = node.childList.map(item => {
            item.parent = node
            return item
          })
          qunt.push(...arr2)
        }
      }
      return nodes
    }
    let result = search3(arr, id)
    return searchPath(result)
  },
  // 初始化格式化员工数据属性
  formatStaffSetInitField(data) {
    data.layout.map(v => {
      if (v.name === 'beanroster') {
        v.rows.map(v1 => {
          if (v1.name === 'picklist_prob_status') {
            v1.field.defaultValue = [
              {
                label: '试用期',
                value: 0,
                color: '#FFFFFF'
              }
            ]
          } else if (v1.name === 'text_positive_status') {
            v1.field.visible = '0'
          } else if (v1.name === 'number_probation_number') {
            v1.label.language.zh = '试用期'
          } else if (v1.name === 'phone_work_tel') {
            v1.field.phoneType = '0'
          }
        })
        v.rows = v.rows.filter(v1 => v1.name !== 'picklist_working_system')
      } else if (v.name === 'beanroster_subform_welfare') {
        v.rows.map(v1 => {
          if (v1.name === 'subform_welfare') {
            v1.componentList.map(v2 => {
              if (v2.type === 'datetime') {
                v2.field.formatType = 'yyyy-MM'
                v2.field.defaultValueId = ''
              }
              if (v2.name === 'subform_number_gjjradix') {
                v2.field.required = '0'
              } else if (v2.name === 'subform_text_gjjdq') {
                v2.field.required = '0'
              }
            })
          }
        })
      } else if (v.name === 'beanroster_subform_parttime') {
        // 公司内兼任
        v.rows[0].componentList.map(v1 => {
          if (
            v1.name === 'subform_reference_department_id' ||
            v1.name === 'subform_reference_post_id'
          ) {
            v1.label.language.zh =
              v1.name === 'subform_reference_department_id' ? '兼任部门' : '兼任职位'
            if (v1.name === 'subform_reference_department_id') {
              v1.field.required = '1'
            }
          }
        })
      } else if (v.name === 'beanroster_subform_salarydetail') {
        // 薪资详情
        v.rows[0].componentList.map(v1 => {
          if (v1.name === 'subform_picklist_salary') {
            v1.field.required = '0'
          } else if (v1.name === 'subform_number_base_salary') {
            v1.field.required = '1'
          }
        })
      }
    })
  },
  // 设置国际化，每个字段都有值
  setI18nFormatLabel(list) {
    let funlabel = label => {
      if (typeof label !== 'string') {
        label.language.zh_TW = label.language.zh
        label.language.en = label.language.zh
      }
    }
    list.map(v => {
      v.rows.forEach(v2 => {
        funlabel(v2.label)
        if (v2.type === 'picklist') {
          v2.entrys.map(v3 => {
            funlabel(v3.label)
          })
        } else if (v2.type === 'subform') {
          v2.componentList.map(v3 => {
            funlabel(v3.label)
            if (v3.type === 'picklist') {
              v3.entrys.map(v4 => {
                funlabel(v4.label)
              })
            }
          })
        }
      })
    })
  },
  // 花名册-教育经历/工作经历分栏里的日期组件改为年月格式
  handleSetStaffDatetime(data, obj) {
    if (obj.typeText === 'beanroster' && obj.type === 1 && data.content) {
      let content = utilClass.unzip(data.content)
      content.layout.map(v => {
        if (v.name === 'beanroster_subform_educ' || v.name === 'beanroster_subform_work') {
          v.rows[0].componentList.map(v1 => {
            if (v1.type === 'datetime' && v1.new_add !== 1) {
              v1.field.formatType = 'yyyy-MM'
            }
          })
        } else if (v.name === 'beanroster') {
          v.rows = v.rows.filter(v1 => v1.name !== 'multi_birthday_type')
        }
        // 处理花名册布局，选项值的国际化问题
        // v.rows.map(v1 => {
        //   if (Array.isArray(v1.entrys) && v1.entrys.length) {
        //     v1.entrys.map(v2 => {
        //       if (typeof v2.label !== 'string') {
        //         v2.label = v2.label.language.zh
        //       }
        //     })
        //   }
        // })
      })
      data.content = utilClass.zip(content)
    }
    return data
  },
  // 处理将“离职人员”改成“停用人员”
  handleStopMember(data, obj) {
    if (Array.isArray(data) && obj.dismiss === 1) {
      data.map(v => {
        if (v.type === -1) {
          // v.name = '停用人员'
          v.name = i18n.t('utils.stopMember')
        }
      })
    }
    return data
  },
  // 获取工资项的可见权限，不可见显示****
  getSalaryItemShowAuth() {
    return new Promise((resolve, reject) => {
      // resolve(true)
      let status = false
      let userInfo = utilClass.decryptMoney(localStorage.getItem('userInfo'))
      let emp = userInfo.employeeInfo
      if (emp.role_type + '' === '2') {
        // 企业所有者
        status = true
        resolve(status)
      } else {
        let requestHeader = JSON.parse(localStorage.getItem('requestHeader'))
        requestHeader.SIGN = utilClass.Encrypt()
        axios({
          method: 'get',
          url: 'salarySocialInsurance/getSocialInsuranceSetting',
          baseURL: baseURL,
          params: {},
          headers: requestHeader
        })
          .then(res => {
            let deplist = userInfo.departmentInfo
            if (
              res.data.data &&
              res.data.data.admin_arr &&
              res.data.data.setting_status + '' === '1'
            ) {
              let arrlist = JSON.parse(res.data.data.admin_arr)
              arrlist.map(v => {
                if (v.type === 1) {
                  if (v.id + '' === emp.id + '') {
                    status = true
                  }
                } else {
                  deplist.map(v1 => {
                    if (v1.id + '' === v.id + '') {
                      status = true
                    }
                  })
                }
              })
            } else if (res.data.data && res.data.data.setting_status + '' === '0') {
              status = true
            }
            resolve(status)
          })
          .catch(() => {
            resolve(false)
          })
      }
    })
  },
  // 颜色十六进制转rgb
  hexToRGB(hex, count) {
    if (!/(^\#([a-fA-F0-9]{3})$)|(^\#([a-fA-F0-9]{6})$)/g.test(hex)) return null
    let allNumberStr = '0123456789abcdef' // 十六进制的所有数字
    let len = hex.slice(1).length
    let str =
      len === 6
        ? hex.slice(1)
        : hex.slice(1)[0].repeat(2) + hex.slice(1)[1].repeat(2) + hex.slice(1)[2].repeat(2)
    let arrStr = str.split('')
    let newArrStr = arrStr.map((item, index) => {
      return allNumberStr.indexOf((item + '').toLowerCase())
    })
    let num1 = newArrStr[0] * 16 + newArrStr[1]
    let num2 = newArrStr[2] * 16 + newArrStr[3]
    let num3 = newArrStr[4] * 16 + newArrStr[5]
    if (count) {
      // 颜色加深或者变浅，整数变浅，负数加深
      num1 += count
      if (num1 > 255) {
        num1 = 255
      }
      if (num1 < 0) {
        num1 = 0
      }
      num2 += count
      if (num2 > 255) {
        num2 = 255
      }
      if (num2 < 0) {
        num2 = 0
      }
      num3 += count
      if (num3 > 255) {
        num3 = 255
      }
      if (num3 < 0) {
        num3 = 0
      }
    }
    return `rgb(${num1}, ${num2}, ${num3})`
  },
  // 颜色十六进制转rgba
  hexToRGBA(colorCur, count, opacity) {
    let color = utilClass.hexToRGB(colorCur, count)
    if (opacity || opacity === 0) {
      let arr = color.split(')')
      let arr1 = arr[0].split('rgb')
      color = 'rgba' + arr1[1] + ',' + opacity + ')'
    }
    return color
  },
  // 处理花名册部门全称
  formatStaffFullDepName(data) {
    if (
      data &&
      data.full_department_name &&
      Array.isArray(data.reference_department_id) &&
      data.reference_department_id.length > 0
    ) {
      data.reference_department_id[0].name = data.full_department_name
    }
  },
  // 处理接口加密
  encryptionTnterface(data, url) {
    if (!window.hjcConfig) {
      let arr = ['moduleOperation/findDataDetail', '/memo/findMemoDetail', '/memo/update']
      if (arr.includes(url)) {
        data.id = utilClass.jsonEncrypt(data.id)
      } else if (url === 'memo/del') {
        data.ids = utilClass.jsonEncrypt(data.ids)
      } else if (url === 'common/savaCommonComment') {
        data.relation_id = utilClass.jsonEncrypt(data.relation_id)
      } else if (url === 'employee/queryEmployeeInfo') {
        data.sign_id = utilClass.jsonEncrypt(data.sign_id)
      } else if (
        url === 'moduleDataAuth/getAuthByRole' ||
        url === 'moduleDataAuth/getBackAuthByRole'
      ) {
        data.roleId = utilClass.jsonEncrypt(data.roleId)
      } else if (url === 'layout/getEnableLayout') {
        if (data.businessDataId) {
          data.businessDataId = utilClass.jsonEncrypt(data.businessDataId)
        }
      } else if (
        url === 'moduleOperation/updateData' ||
        url === 'moduleOperation/updateCompleteData'
      ) {
        data.id = utilClass.jsonEncrypt(data.id)
      } else if (url === 'moduleOperation/deleteData') {
        if (data.ids) {
          data.ids = utilClass.jsonEncrypt(data.ids)
        }
      } else if (url === '/workbench/getScheduleDetailNew') {
        if (data.memberIds) {
          data.memberIds = utilClass.jsonEncrypt(data.memberIds)
        }
      } else if (url === 'webform/getWebformDataDetail') {
        if (data.randomCode) {
          data.randomCode = utilClass.jsonEncrypt(data.randomCode)
        }
      } else if (url === '/workbench/getWorkbenchLayout') {
        if (data.workbenchId) {
          data.workbenchId = utilClass.jsonEncrypt(data.workbenchId)
        }
      } else if (url === 'bizflow/getCurrentSections') {
        if (data.dataId) {
          data.dataId = utilClass.jsonEncrypt(data.dataId)
        }
      } else if (url === 'salarySocialInsuranceAccumulationFund/selectEmployeeList') {
        data = { data: utilClass.jsonEncrypt(JSON.stringify(data)) }
      } else if (
        url === '/dataAnalysis/getDataAnalysisDetail' ||
        url === '/dataAnalysis/getDataAnalysisLayout'
      ) {
        if (data.analysisId) {
          data.analysisId = utilClass.jsonEncrypt(data.analysisId)
        }
      }
    }
  },
  // 处理员工管理和考勤
  handleRosterAttenAuth(config) {
    if (config.url === '/dataAnalysis/getDataAnalysisDetailSingle') {
      // 处理传参压缩
      config.data = {
        data: utilClass.zip(config.data)
      }
    }
  },
  hanldeResponseUnzip(response) {
    // 处理返回解压
    if (response && response.data && response.data.data) {
      if (
        response.config.url.includes('/dataAnalysis/getDataAnalysisDetailSingle') &&
        response.data.data.data
      ) {
        try {
          response.data.data = utilClass.unzip(response.data.data.data)
        } catch (error) {}
      }
      // if (response.config.url.includes('common/file/upload')) { // 通用上传返回处理url
      //   if (Array.isArray(response.data.data) && response.data.data.length) {
      //     response.data.data.map(v => {
      //       v.file_url = decodeURIComponent(v.file_url)
      //       let arr = v.file_url.split('fileName=')
      //       let arr1 = arr[1].split('&fileSize')
      //       let arr2 = arr1[0].split('/')
      //       let arr3 = []
      //       arr2.map((v1, k1) => {
      //         if (k1 === arr2.length - 1) {
      //           arr3.push(encodeURIComponent(v1))
      //         } else {
      //           arr3.push(v1)
      //         }
      //       })
      //       v.file_url = arr[0] + 'fileName=' + (arr3.join('/')) + '&fileSize' + arr1[1]
      //     })
      //   }
      // }
    }
  },
  imgScalOptions: {
    // 背景图样式处理
    0: ' center center / cover no-repeat', // 填充
    1: ' center center / contain no-repeat', // 等比例
    2: ' center center repeat', // 平铺
    3: ' center top / 100% 100% no-repeat', // 拉伸
    4: ' center center no-repeat' // 原图
  },
  // 数据分析，数值字段数据格式显示处理
  showChartValueFormat(value, field, hiddenUnit) {
    let resultValue = value
    let resultUnit = ''
    if (value || value === 0) {
      let str = value + ''
      if (str.includes('%')) {
        str = str.replace(/%/gi, '')
      }
      if (field.num_show_type === '1' || field.num_show_type === '2') {
        if (field.num_separator) {
          str = utilClass.setNumDelimiter(str, '1')
        }
        if (field.num_decimal) {
          // 显示小数位数
          let decimalArr = str.split('.')
          let lengthArr = []
          if (decimalArr[1] && decimalArr[1].length) {
            // 之前存在小数位数
            if (decimalArr[1].length === field.num_decimal_v) {
              // 旧的小数位和设置的一致
              str = decimalArr[0] + ('.' + decimalArr[1])
            } else if (decimalArr[1].length > field.num_decimal_v) {
              // 旧的小数位大于设置的
              str = decimalArr[0] + ('.' + decimalArr[1].substring(0, field.num_decimal_v))
            } else {
              // 旧的小数位小于设置的
              for (let i = 1; i <= field.num_decimal_v - decimalArr[1].length; i++) {
                lengthArr.push('0')
              }
              str = decimalArr[0] + ('.' + decimalArr[1] + lengthArr.join(''))
            }
          } else {
            // 不存在
            for (let i = 1; i <= field.num_decimal_v; i++) {
              lengthArr.push('0')
            }
            str = decimalArr[0] + ('.' + lengthArr.join(''))
          }
        } else {
          // 不显示小数位数
          str = str.split('.')[0]
        }
      }
      resultValue = str
    }
    if (field.num_show_type === '1') {
      // 数值量级
      if (field.num_weight && field.num_weight_v) {
        resultUnit += { 1: '千', 2: '万', 3: '百万', 4: '亿', 5: '十亿' }[field.num_weight_v]
      }
      if (field.num_unit) {
        // 数值单位
        resultUnit += field.num_unit_v || ''
      }
    } else if (field.num_show_type === '2') {
      resultUnit = '%'
    }
    return resultValue + (hiddenUnit ? '' : resultUnit)
  },
  // 图片压缩方法
  pictureCompress(files, size, callBack) {
    // files 文件列表，size 压缩比例，callBack回调函数
    let base64TransToFile = dataImage => {
      let arr = dataImage.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let suffix = mime.split('/')[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], `${new Date().getTime() + '_img'}.${suffix}`, { type: mime })
    }
    let newFiels = []
    for (let i = 0; i < files.length; i++) {
      lrz(files[i], { quality: 1 - size }).then(function (results) {
        newFiels.push(base64TransToFile(results.base64))
        if (i === files.length - 1) {
          callBack(newFiels)
        }
      })
    }
  },
  // 列表转树形结构
  listToTree(res, parentKey, subKey) {
    let array = []
    res.forEach(item => {
      item.children = res.filter(info => info[parentKey] === item[subKey])
      if (!item[parentKey]) {
        array.push(item)
      }
    })
    return array
  },
  // 下划线转驼峰
  convertToCamelCase(str) {
    return str.replace(/_([a-z])/g, function (match, group1) {
      return group1.toUpperCase()
    })
  },
  // 处理上传附件 xss攻击脚本
  handleUploadXss(fileList, callBack) {
    if (fileList && fileList.length) {
      let status = ''
      for (let i = 0; i < fileList.length; i++) {
        let file = fileList[i]
        if (file) {
          const reader = new FileReader()
          reader.onload = function (e) {
            const xml = e.target.result // 获取文件内容（XML）
            if (
              file.type === 'image/svg+xml' &&
              (xml.includes('script') || xml.includes('alert') || xml.includes('onclick'))
            ) {
              status = '上传的文件中有攻击性脚本，请重新上传'
            }
            if (i === fileList.length - 1) {
              callBack(status)
            }
          }
          reader.readAsText(file)
        }
      }
    } else {
      callBack()
    }
  },
  //获取url参数
  getUrlParams(url) {
    const search = url ? new URL(url, window.location.href).search : window.location.search
    const params = {}
    const usp = new URLSearchParams(search)
    usp.forEach((value, key) => {
      if (params.hasOwnProperty(key)) {
        if (Array.isArray(params[key])) params[key].push(value)
        else params[key] = [params[key], value]
      } else {
        params[key] = value
      }
    })
    return params
  },
  // 标准化取值，取value值组成数组返回
  normalizeValues(rawValue) {
    if (rawValue == null) return []
    const arr = Array.isArray(rawValue) ? rawValue : [rawValue]
    return arr.map(v => v?.value).filter(v => v !== undefined && v !== null)
  }
}
export default utilClass
